<template>
	<div class="create-container">
		<div class="create-host">
			<div class="jc-page-header">
				<div class="jc-container">
					<el-page-header show-back-icon :title="$t('create.text.makeCps')" @back="jump_to_up()" class="relative">
						<template slot="content">
							<div class="jc-list__header--right">
								<a :href="Config.BUY_HELP_URL" target="_blank" class="fr buy-info">
									{{ $t('create.text.buyMustKnow') }}
								</a>
							</div>
						</template>
					</el-page-header>
				</div>
			</div>
			<div class="jc-page-content">
				<div class="jc-container pr">
					<div class="buildTab">
						<ul>
							<li id="tab1" @click="setTab('tab', 1, 2)" class="hover">
								{{ $t('create.text.yearlyOrMonthly') }}
								<div class="jc-badge-discount">{{ $t('create.text.sale') }}</div>
							</li>
							<li id="tab2" @click="setTab('tab', 2, 2)" v-if="isVip">
								{{ $t('create.text.byConfigurations') }}
							</li>
						</ul>
					</div>
					<div class="buildCon" id="con-tab-1">
						<div class="infoBox">
							<!-- 地域与可用区 -->
							<div class="jc-page-card">
								<div class="jc-page-card-header">
									<h3 class="jc-page-card-title">{{ $t('create.text.regionAndAz') }}</h3>
								</div>
								<el-form class="jc-form cps-create-form" label-width="130px">
									<el-form-item :label="$t('create.text.region') | withColon">
										<el-radio-group v-model="selectedRegion" @change="regionChange">
											<el-radio-button v-for="(regionName, region, index) in regions" :key="region"
												:label="region">
												{{ regionName }}
											</el-radio-button>
										</el-radio-group>
										<el-tooltip effect="dark" class="ml10" placement="right">
											<div slot="content" class="my-os-disk-tip">{{ $t('create.tooltip.region') }}
											</div>
											<a><i class="jc-icon-question"></i></a>
										</el-tooltip>
									</el-form-item>
									<el-form-item :label="$t('create.text.az') | withColon">
										<el-radio-group v-model="selectedZone" @change="zonesChange">
											<el-radio-button v-for="(azName, az, index) in zones[selectedRegion]" :key="az"
												:label="az">
												{{ azName }}
											</el-radio-button>
										</el-radio-group>
										<el-tooltip effect="dark" class="ml10" placement="right">
											<div slot="content" class="my-os-disk-tip">{{ $t('create.tooltip.az') }}</div>
											<a><i class="jc-icon-question"></i></a>
										</el-tooltip>
									</el-form-item>
								</el-form>
							</div>

							<!--------- 规格 --------->
							<div class="jc-page-card">
								<div class="jc-page-card-header">
									<h3 class="jc-page-card-title">{{ $t('create.text.spec') }}</h3>
								</div>
								<el-form class="jc-form cps-create-form" label-width="130px">
                                    <!-- 系列 -->
									<el-form-item :label="$t('create.text.series') | withColon">
										<el-radio-group v-model="selectedSeries" @change="changeSeries">
											<el-radio-button class="no-border-left"
												v-for="(series) in Object.keys(deviceTypesTable)" :key="series"
												:label="series">{{ seriesMap[series] }}
											</el-radio-button>
										</el-radio-group>
									</el-form-item>
									<div class="select-type">
										<div class="search-label"><span>{{ $t('detail.text.spec') | withColon }}</span>
										</div>
										<el-input v-model="searchType" :placeholder="$t('retailInstance.text.example')"
											@keyup.enter.native="handleIconClick()" class="search-input"></el-input>
										<el-button type="primary" class="search-icon" @click="handleIconClick()">{{
											$t('retailInstance.text.search') }}</el-button>
									</div>
									<el-form-item>
										<div class="jc-form-box">
											<div style="overflow:hidden;margin-right:-30px;width: 100%;">
												<el-table :data="deviceTypesTable[selectedSeries]"
													:empty-text="$t('retailInstance.text.empty')" style="width:830px;" class="instance-type"
													border>
													<!-- 规格类型 -->
													<el-table-column min-width="330" prop="name"
														:label="$t('create.text.specType')">
														<template slot-scope="scope">
															<el-radio-group
																:disabled="!deviceTypesNum[scope.row.deviceType] || isCalculatIng || isConfigurationsCalculatIng"
																v-model="selectedStandard"
																@input="selectStandard(scope.row.deviceType, scope.row)">
																<el-radio :label="scope.row.deviceType">
																	<span v-html="isIncludeBra(scope.row.name)"></span>
																</el-radio>
															</el-radio-group>
															<el-tooltip placement="bottom-start"
																v-if="!deviceTypesNum[scope.row.deviceType]">
																<span class="sold-out">{{ $t('create.text.soldOut')
																}}</span>
																<div slot="content" class="my-app-tip"
																	style="max-width:200px;">
																	<span
																		v-if="selectedHostNumber > 1 && !deviceTypesNum[scope.row.deviceType]">{{
																			$t('create.tooltip.notEnough') }}</span>
																	<span v-else>{{ $t('create.tooltip.soldOut') }}</span>{{
																		$t('create.tooltip.cusService') }}<a
																		v-bind:href="Config.WORK_URL" target="_blank"
																		style="color:#2C68FF">{{ $t('create.tooltip.ticket')
																		}}</a>
																</div>
															</el-tooltip>
														</template>
													</el-table-column>
													<!-- 规格 -->
													<el-table-column min-width="240" prop="deviceType"
														:label="$t('create.text.spec')">
														<template slot-scope="scope">
															<span :title="scope.row.deviceType">{{ scope.row.deviceType
															}}</span>
														</template>
													</el-table-column>
													<!-- CPU -->
													<el-table-column prop="cpuDetail" min-width="150"
														:label="$t('create.text.cpu')">
														<template slot-scope="scope">
															<span :title="scope.row.cpuDetail">
																{{ scope.row.cpuDetail }}
															</span>
														</template>
													</el-table-column>
													<!-- 内存 -->
													<el-table-column prop="memConcise" min-width="75"
														:label="$t('create.text.memory')">
														<template slot-scope="scope">
															<span :title="scope.row.memDetail">
																{{ scope.row.memDetail }}
															</span>
														</template>
													</el-table-column>
													<!-- 网卡 -->
													<el-table-column prop="ifConcise" min-width="130"
														:label="$t('create.text.netCard')">
														<template slot-scope="scope">
															<span>{{ scope.row.ifConcise }}</span>
														</template>
													</el-table-column>
													<!-- GPU -->
													<el-table-column prop="gpuConcise" min-width="90"
														:label="$t('create.text.gpu')">
														<template slot-scope="scope">
															<span>{{ scope.row.gpuConcise | maybeEmpty }}</span>
														</template>
													</el-table-column>
												</el-table>
											</div>
										</div>
										<p>{{ $t('create.text.currentDeviceType') }}
											<span class="highlight-font-color">
												{{ currentDeviceType }}
											</span>
											{{ currentDeviceTypeDetail }}
										</p>
										<p class="el-form-item-help custom-margin-top">
											{{ $t('create.help.spec') }}
											<a v-bind:href="Config.TYPE_HELP_URL" target="_blank">
												{{ $t('create.help.detail') }}
											</a>
										</p>
									</el-form-item>
								</el-form>
							</div>

							<!--------- 镜像 -------->
							<div class="jc-page-card" id="imgType">
								<div class="jc-page-card-header">
									<h3 class="jc-page-card-title">{{ $t('create.text.mirror') }}</h3>
								</div>
								<el-form class="jc-form cps-create-form" label-width="130px" :model="ruleFormType"
									:rules="rulesType" ref="ruleFormType">
                                    <!-- 镜像类型 -->
									<el-form-item :label="$t('create.text.mirrorType') | withColon">
                                        <span v-if="!imageTypes.length">--</span>
										<el-radio-group v-model="selectedImageType" v-else>
											<el-radio-button v-for="(item, key, index) in imageTypes" :key="index"
												:label="key">{{ item.sourceName }}
											</el-radio-button>
										</el-radio-group>
									</el-form-item>
                                    <!-- 操作系统 -->
									<el-form-item :label="$t('create.text.os') | withColon">
                                        <!-- 初始值osTypes 没有时，也展示-- -->
                                        <span v-if='!showOsTypes || (JSON.stringify(osTypes) === `{"":[]}`)'>--</span>
										<el-radio-group v-model="selectedOS" v-else>
											<el-radio-button v-for="(item, key, index) in osTypes" :key="index"
												:label="key">
											</el-radio-button>
										</el-radio-group>
									</el-form-item>
                                    <!-- 系统版本 -->
									<el-form-item :label="$t('create.text.osVersion') | withColon" ref="osVersion" required
										prop="type" :show-message="false">
										<el-select v-model="selectedOSTypeId"
											:placeholder="$t('create.placeholder.version')">
											<el-option v-for="item in osTypes[selectedOS]" :key="item.osTypeId"
												:label="item.osName" :value="item.osTypeId"></el-option>
										</el-select>
										<p class="el-form-item-help custom-margin-top custom-wukong-tip" v-show="isGameServer">
											{{ $t('create.help.systemVersionSpec') }}
											<a :href="gameCreateUrl" target="_blank">
												{{ $t('create.help.systemVersionDetail') }}
											</a>
										</p>
									</el-form-item>
								</el-form>
							</div>

							<!-------- 存储 ----------->
							<div class="jc-page-card" id="storage">
								<div class="jc-page-card-header">
									<h3 class="jc-page-card-title">{{ $t('create.text.storage') }}</h3>
								</div>
								<el-form class="jc-form cps-create-form" label-width="130px">
                                    <!-- 系统盘 -->
									<el-form-item :label="$t('create.text.sysDisk') | withColon">
										<span>{{ selectedSysRaidName | maybeEmpty }}</span>
										<el-tooltip class="ml10" effect="dark" placement="right" content="Right Top">
											<div slot="content" class="my-os-disk-tip">{{ $t('create.tooltip.sysDisk') }}
											</div>
											<a><i class="jc-icon-question"></i></a>
										</el-tooltip>
									</el-form-item>
                                    <!-- 系统盘总容量 -->
									<el-form-item :label="$t('create.text.sysDiskCapacity') | withColon">
										<span>{{ sysDiskCapacity }}</span>
										<span class="el-form-item-help">{{ $t('create.text.sysDiskCapacityUnitTip')
										}}</span>
									</el-form-item>
                                    <!-- 系统盘分区 -->
									<el-form-item :label="$t('retailInstance.text.systemDataPartitions') | withColon">
										<template v-if="systemType === 'windows'">
											<span>{{ $t('retailInstance.text.emptyPartition') }}</span>
										</template>
										<template v-else>
											<el-radio-group v-model="selectedPartitionMode">
												<el-radio v-for="(item, index) in systemDiskPartitionModes"
													:key="item.value" :label="item.value">
													{{ item.label }}
												</el-radio>
											</el-radio-group>
											<el-tooltip class="ml10" effect="dark" placement="right" content="Right Top">
												<div slot="content" class="my-os-disk-tip">
													{{ $t('create.tooltip.systemPartition') }}
												</div>
												<a><i class="jc-icon-question"></i></a>
											</el-tooltip>
											<section class="defaultPartition" v-if="selectedPartitionMode === 'default'"
												v-html="defaultSystemDataPartitions">
											</section>
											<custom-partition ref="systemPartition"
												:visible="selectedPartitionMode === 'custom'" :region="selectedRegion"
												diskType="system" :partitionInfos="systemDataPartitions"
												:otherPartitionInfos="dataDiskPartitions" :isCentOS66="isCentOS66"
												:totalDiskSize="systemDiskSize">
											</custom-partition>
										</template>
									</el-form-item>
                                    <!-- 数据盘 -->
									<el-form-item :label="$t('create.text.dataDisk') | withColon">
										<template v-if="raids.length">
											<div v-for="(item, key, index) in raids" :key="item.raidTypeId"
												@click="selectDataRaid(item)">
												<el-tooltip class="ml5 mt5 dataDiskCardBox" effect="dark" placement="bottom-start"
													content="BOTTOM Center">
													<div slot="content" class="my-os-disk-tip data-disk">
														{{ item.description }}
													</div>
													<el-card :line=true class="deviceType cps-raid-card"
														:class="{ 'selected-box-card': item.raidTypeId == selectedDataRaidId }">
														<div slot="header" class="clear-fix"
															:class="{ 'active-card': item.raidTypeId == selectedDataRaidId }">
															<span class="item text">{{ radisNameMap[item.raidType] }}</span>
														</div>
														<el-form>
															<p class="tc">{{ item.volumeDetail }}</p>
														</el-form>
													</el-card>
												</el-tooltip>
											</div>
										</template>
										<span v-else>--</span>
									</el-form-item>
                                    <!-- 数据盘总容量 -->
									<el-form-item v-if="raids.length"
										:label="$t('create.text.dataDiskCapacity') | withColon">
										<span>{{ dataDiskCapacity }}</span>
										<span class="el-form-item-help">{{ $t('create.text.sysDiskCapacityUnitTip')
										}}</span>
									</el-form-item>
                                    <!-- 数据盘分区 -->
									<el-form-item :label="$t('retailInstance.text.dataDiskPartition') | withColon"
										v-if="raids.length">
										<template v-if="systemType === 'windows'">
											<span>{{ $t('retailInstance.text.emptyPartition') }}</span>
										</template>
										<template v-else>
											<el-radio-group v-model="selectedDataDiskPartitionMode">
												<el-radio v-for="(item, index) in dataDiskPartitionModes" :key="item.value"
													:label="item.value">
													{{ item.label }}
												</el-radio>
											</el-radio-group>
											<section class="defaultPartition"
												v-if="selectedDataDiskPartitionMode === 'default'"
												v-html="defaultDataDiskPartitions">
											</section>
                                            <!-- 数据盘分区-自定义分区-列表 -->
											<custom-partition ref="dataPartition"
												:visible="selectedDataDiskPartitionMode === 'custom'"
												:region="selectedRegion" diskType="data"
												:partitionInfos="dataDiskPartitions"
												:otherPartitionInfos="systemDataPartitions" :isCentOS66="isCentOS66"
												:totalDiskSize="dataDiskSize">
											</custom-partition>
										</template>
									</el-form-item>
								</el-form>
							</div>
							<!-- 网络数量与名称 -->
							<div class="jc-page-card">
								<div class="jc-page-card-header">
									<h3 class="jc-page-card-title">{{ $t('create.text.networkQuantityAndName') }}</h3>
								</div>
								<el-form class="jc-form cps-create-form" label-width="130px">
									<!--网络接口数量-->
									<el-form-item :label="$t('create.text.networkQuantity') | withColon">
										<el-radio-group v-model="selectedNetworkQuantity">
											<el-radio-button v-for="(item, index) in networkQuantity" :key="item.value"
												:label="item.value">{{ item.label }}
											</el-radio-button>
										</el-radio-group>
										<el-tooltip class="ml10" effect="dark" placement="right" content="Right Top">
											<div slot="content" class="my-os-disk-tip">
												{{ $t('create.tooltip.networkQuantityTip') }}
											</div>
											<a><i class="jc-icon-question"></i></a>
										</el-tooltip>
									</el-form-item>
									<!--网络接口名称-->
									<el-form-item :label="$t('create.text.networkName') | withColon">
										<span v-if="selectedNetworkQuantity === 'bond'">{{
											$t('create.text.singleInternetAccessChiefName') }}</span>
										<span v-else>
											{{ $t('create.text.chiefAndSubInternetAccessName') }}
										</span>
										<el-tooltip class="ml10" effect="dark" placement="right" content="Right Top">
											<div slot="content" class="my-os-disk-tip">{{ selectedNetworkQuantity ===
												'bond' ? $t('create.tooltip.mainNetwork') : $t('create.tooltip.subNetwork')
											}}
											</div>
											<a><i class="jc-icon-question"></i></a>
										</el-tooltip>
									</el-form-item>
								</el-form>
							</div>
							<!-- 网口与带宽设置 -->
							<div class="jc-page-card network-info" id="network">
								<div class="jc-page-card-header">
									<h3 class="jc-page-card-title">{{ $t('create.text.networkAndBandWidth') }}</h3>
								</div>
								<!-- 主网口 -->
								<div>
									<h3 class="jc-form-content-title">{{ this.selectedNetworkQuantity === 'dual'
										?
										$t('create.text.chiefInternetAccessName') :
										$t('create.text.singleInternetAccessChiefName') }}
									</h3>
									<el-form class="jc-form cps-create-form" label-width="130px" ref="networkInfo"
										:rules="networkInfoRules" :model="netInfo">
										<!--切换私有网络或者子网，清空别名IP范围列表-->
										<el-alert :title="$t('subnet.help.changeSubnetForAliasIpWarning')" type="error"
											:closable="false" v-if="addAliasIpRangeVisible"
											style="margin-left:65px; margin-bottom:20px;width:90%">
										</el-alert>
										<!-- 私有网络 -->
										<el-form-item :label="$t('privateNetInstance.privateNet') | withColon"
											class="net-select" prop="selectVpcId" ref="selectVpcId">
											<el-select :loading="privateNetInstanceVpcLoading" v-model="netInfo.selectVpcId" class="select-vpc" style="width: 520px"
												@change="(id) => vpcChange(id, 'netInfo')"
												@visible-change="(isVisible) => getRealTimeVpc(isVisible, 'netInfo')"
												:placeholder="$t('privateNetInstance.chooseVPC')">
												<el-option v-for="(vpc, index) in vpcShowList" :key="vpc.vpcId"
													:label="vpc.showName" :value="vpc.vpcId">
												</el-option>
											</el-select>
											<el-button type="text" @click="jumpToVpcList">
												{{ $t('privateNetInstance.createPrivateNetwork') }}
											</el-button>
											<span slot="hint" v-if="netInfo.selectVpcId && netInfo.selectVpcCidr">{{
												$t('privateNetInstance.privateNetCidr', [netInfo.selectVpcCidr]) }}</span>
											<span slot="hint" v-if="netInfo.selectVpcId && netInfo.selectVpcIpv6Cidr">{{
												$t('privateNetInstance.privateNetIpv6Cidr', [netInfo.selectVpcIpv6Cidr])
											}}</span>
										</el-form-item>
										<!-- 子网 -->
										<el-form-item :label="$t('privateNetInstance.subnet') | withColon"
											class="net-select" prop="selectSubnetId" ref="selectSubnetId">
											<el-select v-model="netInfo.selectSubnetId" class="select-vpc"
                                                style="width: 520px"
												:disabled="netInfo.subnetCount === 0"
												@change="(subnetId) => subnetChange(subnetId, 'netInfo')"
												@visible-change="(isVisible) => getRealTimeSubnet(isVisible, 'netInfo')"
												:placeholder="netInfo.subnetCount === 0 ? $t('privateNetInstance.notSubnet') : $t('privateNetInstance.chooseSubnet')">
												<el-option v-for="(subnet, index) in subnetShowList" :key="subnet.subnetId"
													:label="subnet.showName" :value="subnet.subnetId">
												</el-option>
											</el-select>
											<el-button type="text" @click="jumpToSubnetList">
												{{ $t('privateNetInstance.createSubNet') }}
											</el-button>
											<span slot="hint" v-if="netInfo.selectSubnetId && netInfo.selectSubnetCidr">{{
												$t('privateNetInstance.privateNetCidr', [netInfo.selectSubnetCidr])
											}}</span>
											<span slot="hint"
												v-if="netInfo.selectSubnetId && netInfo.selectSubnetIpv6Cidr">{{
													$t('privateNetInstance.privateNetIpv6Cidr', [netInfo.selectSubnetIpv6Cidr])
												}}</span>
										</el-form-item>
										<!-- 内网IP -->
										<el-form-item :label="$t('privateNetInstance.intranetIp') | withColon" class='pt20'>
											<div class="ip-input">
												<el-form-item>
													<el-select v-model="netInfo.isAuto" @change="clearInputIp('netInfo')">
														<el-option v-for="(operate, index) in netInfo.ipOperations"
															:key="operate.value" :value="operate.value"
															:label="operate.label">
														</el-option>
													</el-select>
												</el-form-item>
												<el-form-item prop="internetIp">
													<el-input :disabled="netInfo.isAuto === 1" class="inner-ip"
														@keyup.native="trimValue('internetIp')" v-model="netInfo.internetIp"
														:placeholder="netInfo.isAuto ? $t('privateNetInstance.autoIpTip') : $t('privateNetInstance.notAutoIpTip')">
													</el-input>
													<p slot="hint" v-if="netInfo.isAuto">
														{{ $t('privateNetInstance.intranetIpTip',
															[netInfo.selectSubnetCidr]) }}
													</p>
													<p slot="hint" v-else>
														{{
															$t('privateNetInstance.internetIpTipTwo',
																[netInfo.selectSubnetCidr])
														}}
													</p>
												</el-form-item>
											</div>
											<section>
												<p v-if="!netInfo.selectVpcIpv6Cidr && !netInfo.selectSubnetIpv6Cidr">
													{{ $t('create.text.openIpv6WithoutVpcTip') }}<a @click="jumpToVpcList"
														href="javascript:void(0)">{{ $t('privateNetwork.open') }}</a></p>
												<p v-else-if="netInfo.selectVpcIpv6Cidr && !netInfo.selectSubnetIpv6Cidr">
													{{ $t('create.text.openIpv6WithoutSubnetTip') }}<a
														@click="jumpToSubnetList" href="javascript:void(0)">{{
															$t('privateNetwork.open') }}</a></p>
												<p v-else-if="netInfo.selectSubnetIpv6Cidr && !netInfo.privateIpv6Visible">
													<a @click="showPrivateIpv6('netInfo')" href="javascript:void(0)"><i
															class="jc-icon-plus"></i>{{ $t('create.text.allotPrivateIpv6')
															}}</a>
												</p>
											</section>
											<div class="ip-input" v-if="netInfo.privateIpv6Visible">
												<el-form-item>
													<el-select v-model="netInfo.isPrivateIpv6Auto"
														@change="(val) => clearPrivateIpv6(val, 'netInfo')">
														<el-option v-for="(operate, index) in netInfo.ipOperations"
															:key="operate.value" :value="operate.value"
															:label="operate.label">
														</el-option>
													</el-select>
												</el-form-item>
												<el-form-item prop="privateIpv6">
													<span v-if="!netInfo.isPrivateIpv6Auto" class="ml20">{{ privateIpv6Pre
													}}</span>
													<el-input :disabled="netInfo.isPrivateIpv6Auto === 1" class="inner-ip"
														:class="{ 'ipv6': !netInfo.isPrivateIpv6Auto }"
														v-model="netInfo.privateIpv6"
														@keyup.native="trimValue('privateIpv6')"
														:placeholder="netInfo.isPrivateIpv6Auto ? $t('privateNetInstance.autoIpTip') : $t('privateNetInstance.notAutoIpv6Tip')">
													</el-input>
													<p slot="hint" v-if="netInfo.isPrivateIpv6Auto">
														{{ $t('privateNetInstance.intranetIpv6Tip',
															[netInfo.selectSubnetIpv6Cidr]) }}
													</p>
													<p slot="hint" v-else>
														{{
															$t('privateNetInstance.internetIpv6TipTwo',
																[netInfo.selectSubnetIpv6Cidr])
														}}
													</p>
												</el-form-item>
												<el-form-item>
													<div class="w45">
														<a class="ml10" @click="closePrivateIpv6('netInfo')"
															href="javascript:void(0)">{{ $t('privateNetwork.delete') }}</a>
													</div>
												</el-form-item>

											</div>
										</el-form-item>
										<!--别名IP范围-->
										<add-alias-ip-range :visible.sync="addAliasIpRangeVisible"
											:subnetDetailData="selectedSubnetDetail"
											:aliasIpRestNumber="aliasIpRestNumber('netInfo')"
											:aliasIpv6RestNumber="aliasIpv6RestNumber('netInfo')"
											selectTargetInternetAccessName="1" type="create" v-model="aliasIpData"
											ref="addAliasIpRange">
										</add-alias-ip-range>
										<!--添加别名IP范围-->
										<el-form-item class="add-alias-ip">
											<el-tooltip :disabled="!(!netInfo.selectSubnetId || addIconDisabled('netInfo'))"
												:content="$t('subnet.help.only10IpAliasForOneInstance')" placement="right">
												<a @click="addAliasIpRange('netInfo')" :class="{
													'cps-dropdown-disabled': addIconDisabled('netInfo')
														|| !selectedSubnetDetail.name
												}">
													<i class="jc-icon-plus"></i>{{ $t('subnet.text.addIpAliasRange') }}
												</a>
											</el-tooltip>
											<span class="ml10">
												{{ $t('subnet.help.moreAliasIpAvailablePart1') }}
											</span>
											<span class="highlight-font-color">{{ aliasIpRestNumber('netInfo') }}</span>
											<span>
												{{ $t('subnet.help.moreAliasIpAvailablePart2') }}
											</span>
											<span v-if="netInfo.selectSubnetId && netInfo.selectSubnetIpv6Cidr">
												{{ $t('subnet.help.moreAliasIpAvailablePart3') }}
											</span>
											<span v-if="netInfo.selectSubnetId && netInfo.selectSubnetIpv6Cidr"
												class="highlight-font-color">{{ aliasIpv6RestNumber('netInfo') }}</span>
											<span v-if="netInfo.selectSubnetId && netInfo.selectSubnetIpv6Cidr">
												{{ $t('subnet.help.moreAliasIpAvailablePart2') }}
											</span>
										</el-form-item>
										<el-form-item :label="$t('create.text.publicIp') | withColon">
											<input id="controlCheckbox" type="checkbox" v-model="netInfo.radioIp" />
											<span class="network-ip">{{ $t('create.text.autoVpc') }}</span>
											<p slot="hint" class="auto-vpc-tip">{{ $t('create.text.autoVpcTip') }}</p>
										</el-form-item>
										<div id="agreeControlArea" v-show="netInfo.radioIp">
											<el-form-item :label="$t('create.text.banCalModel') | withColon">
												<el-radio-group v-model="netInfo.selectedPaymentType">
													<el-radio-button v-for="(item, key) in bandwidthPaymentTypes"
														:key="item.key" :label="item.value">
														{{ item.label }}
													</el-radio-button>
												</el-radio-group>
												<el-tooltip class="ml10" effect="dark" placement="right"
													content="Right Top">
													<div slot="content" class="my-os-disk-tip">
														{{ $t('create.tooltip.cal') }}<a
															v-bind:href="Config.Band_Width_BillUrl" target="_blank">{{
																$t('create.tooltip.detail') }}&gt;&gt;</a>
													</div>
													<a><i class="jc-icon-question"></i></a>
												</el-tooltip>
												<p slot="hint" class="auto-vpc-tip"
													v-if="netInfo.selectedPaymentType === 3">{{
														$t('create.text.autoJoinShareBandwidth') }}</p>
											</el-form-item>
											<el-form-item :label="$t('create.text.line') | withColon">
												<el-radio-group v-model="netInfo.selectedLineType">
													<el-radio-button v-for="(item, key, index) in lineTypes" :key="key"
														:label="key">{{ item }}
													</el-radio-button>
												</el-radio-group>
												<el-tooltip class="ml10" effect="dark" placement="right"
													content="Right Top">
													<div slot="content" class="my-os-disk-tip">
														{{ $t('create.tooltip.line', [lineTypes[netInfo.selectedLineType]])
														}}
													</div>
													<a><i class="jc-icon-question"></i></a>
												</el-tooltip>
											</el-form-item>
											<el-form-item :label="$t('create.text.bandLimit') | withColon"
												v-if="netInfo.selectedPaymentType !== 3">
												<div class="el-form-item-inline">
													<el-slider v-model="netInfo.tmpMaxBandwidth" show-input
														@change="(val) => calSelectedMaxBandwidth(val, 'netInfo')"
														:max="200" :marks="marks" :debounce="0" :min="1"
														class="jc-slider-custom">
													</el-slider>
												</div>
												<p class="el-form-item-help mt20">
													{{ $t('create.help.ddosVpc') }}
													<a v-bind:href="Config.DDOS_URL" target="_blank">
														{{ $t('create.help.ddosVpcGuid') }}
													</a>
												</p>
											</el-form-item>
											<!--加入共享带宽-->
											<select-bandwidth-package v-show="netInfo.selectedPaymentType === 3"
												v-model="netInfo.sharedBandwidthForm" :region="selectedRegion"
												:lineType="netInfo.selectedLineType">
											</select-bandwidth-package>
										</div>
									</el-form>
								</div>
								<!-- 辅网口 -->
								<div v-show="selectedNetworkQuantity === 'dual'" id="extensionNet" class="extension-net">
									<h3 class="jc-form-content-title">{{ $t('create.text.subInternetAccessName') }}</h3>
									<el-form class="jc-form cps-create-form" label-width="130px" ref="extensionNetInfo"
										:rules="networkInfoRules" :model="extensionNetInfo">
										<!--切换私有网络或者子网，清空别名IP范围列表-->
										<el-alert :title="$t('subnet.help.changeSubnetForAliasIpWarning')" type="error"
											:closable="false" v-if="extensionAddAliasIpRangeVisible"
											style="margin-left:65px;margin-bottom:20px;width:90%">
										</el-alert>
										<!-- 私有网络 -->
										<el-form-item :label="$t('privateNetInstance.privateNet') | withColon"
											class="net-select" prop="selectVpcId" ref="selectVpcId">
											<el-select :loading="privateNetInstanceExVpcLoading" v-model="extensionNetInfo.selectVpcId" class="select-vpc"
												@change="(id) => vpcChange(id, 'extensionNetInfo')"
												@visible-change="(isVisible) => getRealTimeVpc(isVisible, 'extensionNetInfo')"
												:placeholder="$t('privateNetInstance.chooseVPC')" style="width: 520px">
												<el-option v-for="(vpc, index) in extionsVpcShowList" :key="vpc.vpcId"
													:label="vpc.showName" :value="vpc.vpcId">
												</el-option>
											</el-select>
											<el-button type="text" @click="jumpToVpcList">
												{{ $t('privateNetInstance.createPrivateNetwork') }}
											</el-button>
											<span slot="hint"
												v-if="extensionNetInfo.selectVpcId && extensionNetInfo.selectVpcCidr">{{
													$t('privateNetInstance.privateNetCidr', [extensionNetInfo.selectVpcCidr])
												}}</span>
											<span slot="hint"
												v-if="extensionNetInfo.selectVpcId && extensionNetInfo.selectVpcIpv6Cidr">{{
													$t('privateNetInstance.privateNetIpv6Cidr',
														[extensionNetInfo.selectVpcIpv6Cidr]) }}</span>
										</el-form-item>
										<!-- 子网 -->
										<el-form-item :label="$t('privateNetInstance.subnet') | withColon"
											class="net-select" prop="selectSubnetId" ref="selectSubnetId">
											<el-select v-model="extensionNetInfo.selectSubnetId" class="select-vpc"
												:disabled="extensionNetInfo.subnetCount === 0"
												@change="(subnetId) => subnetChange(subnetId, 'extensionNetInfo')"
												@visible-change="(isVisible) => getRealTimeSubnet(isVisible, 'extensionNetInfo')"
												:placeholder="extensionNetInfo.subnetCount === 0 ? $t('privateNetInstance.notSubnet') : $t('privateNetInstance.chooseSubnet')" style="width: 520px">
												<el-option v-for="(subnet, index) in extensionsubnetShowList"
													:key="subnet.subnetId" :label="subnet.showName"
													:value="subnet.subnetId">
												</el-option>
											</el-select>
											<el-button type="text" @click="jumpToSubnetList">
												{{ $t('privateNetInstance.createSubNet') }}
											</el-button>
											<span slot="hint"
												v-if="extensionNetInfo.selectSubnetId && extensionNetInfo.selectSubnetCidr">{{
													$t('privateNetInstance.privateNetCidr', [extensionNetInfo.selectSubnetCidr])
												}}</span>
											<span slot="hint"
												v-if="extensionNetInfo.selectSubnetId && extensionNetInfo.selectSubnetIpv6Cidr">{{
													$t('privateNetInstance.privateNetIpv6Cidr',
														[extensionNetInfo.selectSubnetIpv6Cidr]) }}</span>
										</el-form-item>
										<!-- 内网IP -->
										<el-form-item :label="$t('privateNetInstance.intranetIp') | withColon" class='pt20'>
											<div class="ip-input">
												<el-form-item>
													<el-select v-model="extensionNetInfo.isAuto"
														@change="clearInputIp('extensionNetInfo')">
														<el-option v-for="(operate, index) in extensionNetInfo.ipOperations"
															:key="operate.value" :value="operate.value"
															:label="operate.label">
														</el-option>
													</el-select>
												</el-form-item>
												<el-form-item prop="internetIp">
													<el-input :disabled="extensionNetInfo.isAuto === 1" class="inner-ip"
														@keyup.native="trimValue('internetIp')"
														v-model="extensionNetInfo.internetIp"
														:placeholder="extensionNetInfo.isAuto ? $t('privateNetInstance.autoIpTip') : $t('privateNetInstance.notAutoIpTip')">
													</el-input>
													<p slot="hint" v-if="extensionNetInfo.isAuto">
														{{ $t('privateNetInstance.intranetIpTip',
															[extensionNetInfo.selectSubnetCidr]) }}
													</p>
													<p slot="hint" v-else>
														{{
															$t('privateNetInstance.internetIpTipTwo',
																[extensionNetInfo.selectSubnetCidr])
														}}
													</p>
												</el-form-item>
											</div>
											<section>
												<p
													v-if="!extensionNetInfo.selectVpcIpv6Cidr && !extensionNetInfo.selectSubnetIpv6Cidr">
													{{ $t('create.text.openIpv6WithoutVpcTip') }}<a @click="jumpToVpcList"
														href="javascript:void(0)">{{ $t('privateNetwork.open') }}</a></p>
												<p
													v-else-if="extensionNetInfo.selectVpcIpv6Cidr && !extensionNetInfo.selectSubnetIpv6Cidr">
													{{ $t('create.text.openIpv6WithoutSubnetTip') }}<a
														@click="jumpToSubnetList" href="javascript:void(0)">{{
															$t('privateNetwork.open') }}</a></p>
												<p
													v-else-if="extensionNetInfo.selectSubnetIpv6Cidr && !extensionNetInfo.privateIpv6Visible">
													<a @click="showPrivateIpv6('extensionNetInfo')"
														href="javascript:void(0)"><i class="jc-icon-plus"></i>{{
															$t('create.text.allotPrivateIpv6') }}</a>
												</p>
											</section>
											<div class="ip-input" v-if="extensionNetInfo.privateIpv6Visible">
												<el-form-item>
													<el-select v-model="extensionNetInfo.isPrivateIpv6Auto"
														@change="(val) => clearPrivateIpv6(val, 'extensionNetInfo')">
														<el-option v-for="(operate, index) in extensionNetInfo.ipOperations"
															:key="operate.value" :value="operate.value"
															:label="operate.label">
														</el-option>
													</el-select>
												</el-form-item>
												<el-form-item prop="privateIpv6">
													<span v-if="!extensionNetInfo.isPrivateIpv6Auto" class="ml20">{{
														extensionPrivateIpv6Pre }}</span>
													<el-input :disabled="extensionNetInfo.isPrivateIpv6Auto === 1"
														class="inner-ip"
														:class="{ 'ipv6': !extensionNetInfo.isPrivateIpv6Auto }"
														v-model="extensionNetInfo.privateIpv6"
														@keyup.native="trimValue('privateIpv6')"
														:placeholder="extensionNetInfo.isPrivateIpv6Auto ? $t('privateNetInstance.autoIpTip') : $t('privateNetInstance.notAutoIpv6Tip')">
													</el-input>
													<p slot="hint" v-if="extensionNetInfo.isPrivateIpv6Auto">
														{{ $t('privateNetInstance.intranetIpv6Tip',
															[extensionNetInfo.selectSubnetIpv6Cidr]) }}
													</p>
													<p slot="hint" v-else>
														{{
															$t('privateNetInstance.internetIpv6TipTwo',
																[extensionNetInfo.selectSubnetIpv6Cidr])
														}}
													</p>
												</el-form-item>
												<el-form-item>
													<div class="w45">
														<a class="ml10" @click="closePrivateIpv6('extensionNetInfo')"
															href="javascript:void(0)">{{ $t('privateNetwork.delete') }}</a>
													</div>
												</el-form-item>

											</div>
										</el-form-item>
										<!--别名IP范围-->
										<add-alias-ip-range :visible.sync="extensionAddAliasIpRangeVisible"
											:subnetDetailData="selectedExtensionSubnetDetail"
											:aliasIpRestNumber="aliasIpRestNumber('extensionNetInfo')"
											:aliasIpv6RestNumber="aliasIpv6RestNumber('extensionNetInfo')"
											selectTargetInternetAccessName="2" type="create" v-model="extensionAliasIpData"
											ref="extensionAddAliasIpRange">
										</add-alias-ip-range>
										<!--添加别名IP范围-->
										<el-form-item class="add-alias-ip">
											<el-tooltip
												:disabled="!(!extensionNetInfo.selectSubnetId || addIconDisabled('extensionNetInfo'))"
												:content="$t('subnet.help.only10IpAliasForOneInstance')" placement="right">
												<a @click="addAliasIpRange('extensionNetInfo')" :class="{
													'cps-dropdown-disabled': addIconDisabled('extensionNetInfo')
														|| !selectedExtensionSubnetDetail.name
												}">
													<i class="jc-icon-plus"></i>{{ $t('subnet.text.addIpAliasRange') }}
												</a>
											</el-tooltip>
											<span class="ml10">
												{{ $t('subnet.help.moreAliasIpAvailablePart1') }}
											</span>
											<span class="highlight-font-color">{{ aliasIpRestNumber('extensionNetInfo')
											}}</span>
											<span>
												{{ $t('subnet.help.moreAliasIpAvailablePart2') }}
											</span>
											<span
												v-if="extensionNetInfo.selectSubnetId && extensionNetInfo.selectSubnetIpv6Cidr">
												{{ $t('subnet.help.moreAliasIpAvailablePart3') }}
											</span>
											<span
												v-if="extensionNetInfo.selectSubnetId && extensionNetInfo.selectSubnetIpv6Cidr"
												class="highlight-font-color">{{ aliasIpv6RestNumber('extensionNetInfo')
												}}</span>
											<span
												v-if="extensionNetInfo.selectSubnetId && extensionNetInfo.selectSubnetIpv6Cidr">
												{{ $t('subnet.help.moreAliasIpAvailablePart2') }}
											</span>
										</el-form-item>
										<el-form-item :label="$t('create.text.publicIp') | withColon">
											<input id="extensionControlCheckbox" type="checkbox"
												v-model="extensionNetInfo.radioIp" />
											<span class="network-ip">{{ $t('create.text.autoVpc') }}</span>
											<p slot="hint" class="auto-vpc-tip">{{ $t('create.text.autoVpcTip') }}</p>
										</el-form-item>
										<div id="agreeControlArea" v-show="extensionNetInfo.radioIp">
											<el-form-item :label="$t('create.text.banCalModel') | withColon">
												<el-radio-group v-model="extensionNetInfo.selectedPaymentType">
													<el-radio-button v-for="(item, key) in bandwidthPaymentTypes"
														:key="item.key" :label="item.value">
														{{ item.label }}
													</el-radio-button>
												</el-radio-group>
												<el-tooltip class="ml10" effect="dark" placement="right"
													content="Right Top">
													<div slot="content" class="my-os-disk-tip">
														{{ $t('create.tooltip.cal') }}<a
															v-bind:href="Config.Band_Width_BillUrl" target="_blank">{{
																$t('create.tooltip.detail') }}&gt;&gt;</a>
													</div>
													<a><i class="jc-icon-question"></i></a>
												</el-tooltip>
												<p slot="hint" class="auto-vpc-tip"
													v-if="extensionNetInfo.selectedPaymentType === 3">{{
														$t('create.text.autoJoinShareBandwidth') }}</p>
											</el-form-item>
											<el-form-item :label="$t('create.text.line') | withColon">
												<el-radio-group v-model="extensionNetInfo.selectedLineType">
													<el-radio-button v-for="(item, key, index) in lineTypes" :key="key"
														:label="key">{{ item }}
													</el-radio-button>
												</el-radio-group>
												<el-tooltip class="ml10" effect="dark" placement="right"
													content="Right Top">
													<div slot="content" class="my-os-disk-tip">
														{{ $t('create.tooltip.line',
															[lineTypes[extensionNetInfo.selectedLineType]]) }}
													</div>
													<a><i class="jc-icon-question"></i></a>
												</el-tooltip>
											</el-form-item>
											<el-form-item :label="$t('create.text.bandLimit') | withColon"
												v-if="extensionNetInfo.selectedPaymentType !== 3">
												<div class="el-form-item-inline">
													<el-slider v-model="extensionNetInfo.tmpMaxBandwidth" show-input
														@change="(val) => calSelectedMaxBandwidth(val, 'extensionNetInfo')"
														:max="200" :marks="marks" :debounce="0" :min="1"
														class="jc-slider-custom">
													</el-slider>
												</div>
												<p class="el-form-item-help mt20">
													{{ $t('create.help.ddosVpc') }}
													<a :href="Config.DDOS_URL" target="_blank">
														{{ $t('create.help.ddosVpcGuid') }}
													</a>
												</p>
											</el-form-item>
											<!--加入共享带宽-->
											<select-bandwidth-package v-show="extensionNetInfo.selectedPaymentType === 3"
												v-model="extensionNetInfo.sharedBandwidthForm" :region="selectedRegion"
												:lineType="extensionNetInfo.selectedLineType">
											</select-bandwidth-package>
										</div>
									</el-form>
								</div>
							</div>
							<!-- 安全设置 -->
							<div class="jc-page-card">
								<div class="jc-page-card-header">
									<h3 class="jc-page-card-title">{{ $t('create.text.securityNetwork') }}</h3>
								</div>
								<el-form class="jc-form cps-create-form" label-width="130px" onsubmit="return false">
									<!-- 防火墙 -->
									<el-form-item :label="$t('privateNetInstance.firewall') | withColon" class="net-select">
										<el-select v-model="firewall" disabled
											:placeholder="netInfo.radioIp ? $t('privateNetInstance.ipTip') : $t('privateNetInstance.notIpTip')">
										</el-select>
										<p slot="hint">
											{{ $t('privateNetInstance.firewallTip') }}
											<a :href="Config.FIRE_HELP_URL" target="_blank">
												{{ $t('privateNetInstance.operateGuid') }}
											</a>
										</p>
									</el-form-item>
								</el-form>
							</div>
							<!-- 基本信息 -->
							<div id="baseInfo" class="jc-page-card">
								<div class="jc-page-card-header">
									<h3 class="jc-page-card-title">{{ $t('create.text.baseInfo') }}</h3>
								</div>
								<el-form class="jc-form cps-create-form" label-width="130px" :model="ruleForm"
									ref="ruleForm" :rules="rules">
									<!--实例名称-->
									<el-form-item :label="$t('detail.text.name') | withColon" prop="hostName"
										:show-message="false" required ref="hostName">
										<el-input v-model="ruleForm.hostName" class="w500" style="width: 520px" @blur="ruleFormTag.hostName = 1"
											@focus="ruleFormTag.hostName = 0"></el-input>
										<el-tooltip class="ml10" effect="dark" placement="right">
											<div slot="content" class="my-os-disk-tip">
												{{ $t('create.help.instanceName') }}
											</div>
											<a><i class="jc-icon-question"></i></a>
										</el-tooltip>
										<p v-if="ruleFormTag.hostName !== 0 && ruleForm.hostName == ''"
											class="el-form-item-help-error">
											{{ $t('create.placeholder.nameNull') }}</p>
										<p v-else class="el-form-item-help"
											:class="{ 'el-form-item-help-error': this.ruleFormTag.hostName == 'error' }">
											{{ $t('create.help.instanceNameRule1') }}</p>
									</el-form-item>
									<!--描述-->
									<el-form-item :label="$t('create.text.desc') | withColon" prop="hostDesc"
										:show-message="false" ref="hostDesc">
										<el-input type="textarea" :rows="4" class="w500" style="width: 520px" v-model="ruleForm.hostDesc"
											placeholder=""></el-input>
										<p class="el-form-item-help"
											:class="{ 'el-form-item-help-error': this.ruleFormTag.hostDesc == 'error' }">
											{{ $t('create.help.desc') }}</p>
									</el-form-item>
									<!--主机名-->
									<el-form-item :label="$t('create.text.hostName') | withColon" prop="mainName"
										:show-message="false" ref="mainName">
										<el-input v-model="ruleForm.mainName" class="w500" style="width: 520px"
											:placeholder="$t('create.placeholder.mainName')"
											@blur="ruleFormTag.mainName = 1" @focus="ruleFormTag.mainName = 0"></el-input>
										<el-tooltip class="ml10" effect="dark" placement="right">
											<div slot="content" class="my-os-disk-tip">{{ $t('create.help.hostName') }}
											</div>
											<a><i class="jc-icon-question"></i></a>
										</el-tooltip>
										<p class="el-form-item-help"
											:class="{ 'el-form-item-help-error': this.ruleFormTag.mainName == 'error' }">
											{{ $t('create.help.mainServerNameRule') }}</p>
									</el-form-item>
									<!--用户名-->
									<el-form-item :label="$t('create.text.username') | withColon">
										<span>{{ hostUserName }}</span>
									</el-form-item>
									<!--设置密码-->
									<el-form-item :label="$t('create.text.setPassword') | withColon">
										<input type="radio" v-model="passwordType" value="custom" id="custom"
											class="label-align" />
										<label for="custom">
											{{ $t('create.text.customizedPassword') }}
										</label>
										<input type="radio" v-model="passwordType" value="auto" id="auto"
											class="auto-password-position label-align" />
										<label for="auto">
											{{ $t('create.text.autoPassword') }}
										</label>
                                        <!-- v-if="selectedOS !== 'Windows' && selectedOS !== 'WindowsPC'" -->
										<input v-if="!isWindowsArr.includes(selectedOS)"  type="radio" v-model="passwordType"
											value="key" id="key" class="auto-password-position label-align" />
                                            <!-- v-if="selectedOS !== 'Windows' && selectedOS !== 'WindowsPC'" -->
										<label v-if="!isWindowsArr.includes(selectedOS)" for="key">
											{{ $t('create.text.publicKey') }}
										</label>
										<el-tooltip class="ml10" effect="dark" placement="right">
											<div slot="content" class="my-os-disk-tip">
												{{ $t('create.tooltip.loginTip') }}
											</div>
											<a><i class="jc-icon-question"></i></a>
										</el-tooltip>
									</el-form-item>
									<!--密码-->
                                    <!-- 设置密码 勾选 自定义密码 才展示 -->
									<el-form-item v-if="passwordType === 'custom'"
										:label="$t('create.text.password') | withColon" required prop="hostPwd"
										:show-message="false" ref="hostPwd">
										<el-input class="w500" style="width: 520px" v-model="ruleForm.hostPwd" type="password"
											auto-complete="off" @blur="ruleFormTag.hostPwd = 1"
											@focus="ruleFormTag.hostPwd = 0"></el-input>
										<p v-if="ruleFormTag.hostPwd !== 0 && ruleForm.hostPwd == ''"
											class="el-form-item-help-error">
											{{ $t('create.placeholder.passNull') }}</p>
										<p v-else class="el-form-item-help"
											:class="{ 'el-form-item-help-error': this.ruleFormTag.hostPwd == 'error' }">
											{{ $t('create.help.password') }}</p>
									</el-form-item>
									<!--确认密码-->
                                    <!-- 设置密码 勾选 自定义密码 才展示 -->
									<el-form-item :label="$t('create.text.passwordConfirm') | withColon" required
										prop="hostConfirmPwd" :show-message="false" ref="hostConfirmPwd"
										v-if="passwordType === 'custom'">
										<el-input class="w500" style="width: 520px" v-model="ruleForm.hostConfirmPwd" type="password"
											auto-complete="off" @blur="ruleFormTag.hostConfirmPwd = 1"
											@focus="ruleFormTag.hostConfirmPwd = 0"></el-input>
										<p v-if="ruleFormTag.hostConfirmPwd !== 0 && ruleForm.hostConfirmPwd == ''"
											class="el-form-item-help-error">
											{{ $t('create.placeholder.confirmPassNull') }}</p>
										<p v-if="ruleFormTag.hostConfirmPwd !== 0 && ruleForm.hostConfirmPwd !== '' && ruleForm.hostPwd !== ruleForm.hostConfirmPwd"
											class="el-form-item-help-error">{{ $t('create.placeholder.passNotSame') }}</p>
									</el-form-item>
									<!--关联SSH密钥-->
									<el-form-item :label="$t('create.text.linkSSHKey') | withColon"
										v-if="passwordType !== 'key'">
										<el-switch v-model="setKeyState" on-text="" off-text=""
											:disabled="isWindowsArr.includes(selectedOS)">
										</el-switch>
										<el-tooltip class="ml10" effect="dark" placement="right">
											<div slot="content" class="my-os-disk-tip">
												{{ $t('create.tooltip.keyPairTips') }}
											</div>
											<a><i class="jc-icon-question"></i></a>
										</el-tooltip>
										<p v-if="!setKeyState">{{ $t('create.text.keyTips') }}</p>
									</el-form-item>
									<!--密钥对单选-->
									<el-form-item :label="$t('create.text.key') | withColon"
										v-if="setKeyState && passwordType !== 'key'" prop="selectKey" :show-message="false">
										<el-select v-model="ruleForm.selectKey" class="select-vpc"
											@visible-change="getRealTimePublicKey"
											:placeholder="$t('listPage.placeholder.choose')"
											:no-data-text="$t('speechCraft.listNoText')">
											<el-option v-for="(key, index) in keyShowList" :key="key.keypairId"
												:label="key.name" :value="key.keypairId">
											</el-option>
										</el-select>
										<el-button type="text" @click="jumpToKeys">
											{{ $t('ssh.text.create') }}
										</el-button>
										<p class="el-form-item-like">
											{{ $t('create.help.publicKeySetting') }}
											<a :href="Config.SSH_HELP_URL" target="_blank">
												{{ $t('privateNetInstance.operateGuid') }}
											</a>
										</p>
									</el-form-item>
									<!--密钥对多选-->
									<el-form-item :label="$t('create.text.key') | withColon" v-if="passwordType === 'key'"
										prop="selectKey">
										<secret-key :region="selectedRegion" v-model="ruleForm.selectKey"></secret-key>
									</el-form-item>
									<!--SOS密钥对-->
									<el-form-item :label="$t('privateNetInstance.SOSKeyPair') | withColon"
										v-if="passwordType === 'key'" prop="sosKey" :show-message="false">
										<sos-secret-key :region="selectedRegion" v-model="ruleForm.sosKey"></sos-secret-key>
									</el-form-item>
								</el-form>
							</div>
							<!-- 高级设置 -->
							<div id="advanced" class="jc-page-card advanced-setting">
								<div class="jc-page-card-header">
									<h3 class="jc-page-card-title">{{ $t('create.text.advanced') }}</h3>
								</div>
								<custom-data :setCustomData.sync="advancedSetting" ref="advancedCustomData"
									:region="selectedRegion" :selectedOS="selectedOS" @getCustomData="getCustomData">
								</custom-data>
								<el-form class="jc-form tags-form" :model="tagForm" label-width="130px" :rules="tagRules">
									<el-form-item class="code-value-tip" :label="$t('listPage.text.tags') | withColon">
										<jcb-tag-creationform v-model="tagForm.tags" ref="tagForm"
											:regionId="selectedRegion" @error="errorHandler">
										</jcb-tag-creationform>
									</el-form-item>
								</el-form>
							</div>
							<!-- 购买量 -->
							<div class="jc-page-card">
								<div class="jc-page-card-header">
									<h3 class="jc-page-card-title">{{ $t('create.text.buyNo') }}</h3>
								</div>
								<el-form class="jc-form cps-create-form" label-width="130px">
									<el-form-item v-if="currentMode === 'tab1'"
										:label="$t('create.text.buyTimeSpan') | withColon">
										<div class="my-time-length">
											<div class="time-slide">
												<ul class="time-choose cl">
													<!--0折用户-->
													<el-tooltip effect="dark" placement="top"
														v-if="allDiscountedInfo[index - 1].message[0] !== ''"
														v-for='index in firstNine' :key="generateGuid()">
														<div slot="content">
															{{ allDiscountedInfo[index - 1].message[0] }} <br />
															{{ allDiscountedInfo[index - 1].message[1] }}
														</div>
														<li @click="selectMonth(index)" :class="getClass(index)">
															<i></i>{{ index }}
														</li>
													</el-tooltip>
													<!--普通用户-->
													<li v-for='index in firstNine' @click="selectMonth(index)"
														:key="generateGuid()" :class="getClass(index)"
														v-if="allDiscountedInfo[index - 1].message[0] === ''">
														{{ index }}
													</li>
													<!--0折用户-->
													<el-tooltip effect="dark" placement="top"
														v-if="allDiscountedInfo[index + 8].message[0] !== ''"
														v-for='index in lastThree' :key="generateGuid()">
														<div slot="content">
															{{ allDiscountedInfo[index + 8].message[0] }} <br />
															{{ allDiscountedInfo[index + 8].message[1] }}
														</div>
														<li @click="selectYear(index)" class="time-discount"
															:class="getClass(12 * index)">
															<i></i>{{ index + $tc('create.text.yearUnit', index) }}
														</li>
													</el-tooltip>
													<!--普通用户-->
													<li v-for='index in lastThree' @click="selectYear(index)"
														:class="getClass(12 * index)"
														v-if="allDiscountedInfo[index + 8].message[0] === ''"
														:key="generateGuid()" class="time-discount">
														{{ index + $tc('create.text.yearUnit', index) }}
													</li>
												</ul>
											</div>
										</div>
									</el-form-item>
									<!--自动续费-->
									<el-form-item v-if="currentMode === 'tab1'"
										:label="$t('create.text.autoRenew') | withColon">
										<input id="autoRenewCheckbox" type="checkbox" v-model="autoRenew" />
										<span>{{ $t('create.text.autoRenewTip') }}</span>
										<el-tooltip class="ml10" effect="dark" placement="right">
											<div slot="content" class="my-app-tip">
												{{ $t('create.tooltip.autoRenew') }}
											</div>
											<a><i class="jc-icon-question"></i></a>
										</el-tooltip>
									</el-form-item>
									<el-form-item :label="$t('create.text.count') | withColon">
										<el-input-number v-model="selectedHostNumber" :min="1"
											:max="netInfo.isAuto ? maxHostNumber : 1" label=""
											@input.native="changeSelectedNumber"></el-input-number>
										<el-tooltip class="ml10" effect="dark" placement="right">
											<div slot="content" class="my-app-tip" v-if="netInfo.isAuto">
												{{ $t('create.help.maxNum') }}<a :href="Config.WORK_URL" target="_blank"
													style="color:#2C68FF">{{ $t('create.tooltip.ticket') }}</a>
											</div>
											<div slot="content" class="my-app-tip" v-else-if="!netInfo.isAuto">
												{{ $t('create.help.onlyOne') }}
											</div>
											<a><i class="jc-icon-question"></i></a>
										</el-tooltip>
									</el-form-item>
								</el-form>
							</div>
						</div>
					</div>
					<!-- 已选配置 -->
					<div id="selected" class="jc-form-create-selected">
						<h3 class="selected-title">
							{{ $t('create.text.selectedConfig') }}</h3>
						<el-form label-width="100px" class="jc-datashow-list">
							<section class="selected-configure">
								<!--地域-->
								<el-form-item :label="$t('create.text.region')">
									<p>{{ regions[selectedRegion] | maybeEmpty }}</p>
								</el-form-item>
								<!--可用区-->
								<el-form-item :label="$t('create.text.az')" :title="$t('create.text.az')">
									<p>{{ zones[selectedRegion][selectedZone] | maybeEmpty }}</p>
								</el-form-item>
								<!--规格-->
								<el-form-item :label="$t('create.text.spec')">
									<p class="selected-ellipsis" :title="selectedStandardName">
										{{ selectedStandardName | maybeEmpty }}
									</p>
								</el-form-item>
								<!--镜像-->
								<el-form-item :label="$t('create.text.mirror')">
									<p>
										{{ selectedOSName | maybeEmpty }}
									</p>
								</el-form-item>
								<!--系统盘-->
								<el-form-item :label="$t('create.text.sysDisk')" :title="$t('create.text.sysDisk')">
									<p>
										{{ selectedSysRaidName | maybeEmpty }}
									</p>
								</el-form-item>
								<!--数据盘-->
								<el-form-item :label="$t('create.text.dataDisk')" :title="$t('create.text.dataDisk')">
									<p class="selected-ellipsis" :title="selectedDataRaidName">
										{{ selectedDataRaidName | maybeEmpty }}
									</p>
								</el-form-item>
								<!--主网口-->
								<div>
									<h3 class="network-title" @click="collapseSelected('netInfo')">
										<span>{{ this.selectedNetworkQuantity === 'dual'
											?
											$t('create.text.chiefInternetAccessName') :
											$t('create.text.singleInternetAccessChiefName') }}</span>
										<i :class="netInfo.collapseSelected ? 'jc-icon-caret-bottom' : 'jc-icon-caret-top'">
										</i>
									</h3>
									<div v-show="!netInfo.collapseSelected">
										<!--私有网络-->
										<el-form-item :label="$t('privateNetInstance.privateNet')">
											<p>{{ netInfo.selectVpcName | maybeEmpty }}</p>
										</el-form-item>
										<!--子网-->
										<el-form-item :label="$t('privateNetInstance.subnet')">
											<p>
												{{ netInfo.selectSubnetName | maybeEmpty }}
											</p>
										</el-form-item>
										<!--内网IP-->
										<el-form-item :label="$t('privateNetInstance.interNetwork')">
											<template v-if="!netInfo.privateIpv6Visible">
												<p v-if="!netInfo.isAuto && netInfo.internetIp !== ''"
													class="selected-ellipsis" :title="netInfo.internetIp">
													{{ netInfo.internetIp }}
												</p>
												<p v-else-if="!netInfo.isAuto && netInfo.internetIp === ''">
													{{ '--' }}
												</p>
												<p v-else>
													{{ $t('privateNetInstance.autoShowTip', [netInfo.selectSubnetCidr]) }}
												</p>
											</template>
											<template v-else>
												<p v-if="!netInfo.isAuto && netInfo.internetIp !== '' && netInfo.isPrivateIpv6Auto"
													class="selected-ellipsis" :title="choosedPrivateIpTitle">
													{{ netInfo.internetIp }}{{ ',' }}{{
														$t('privateNetInstance.intranetIpv6Tip', [netInfo.selectSubnetIpv6Cidr])
													}}
												</p>
												<p v-else-if="!netInfo.isAuto && netInfo.internetIp !== '' && !netInfo.isPrivateIpv6Auto && netInfo.privateIpv6 !== ''"
													class="selected-ellipsis" :title="choosedPrivateIpTitle">
													{{ netInfo.internetIp + ',' + privateIpv6Pre + netInfo.privateIpv6 }}
												</p>
												<p v-else-if="netInfo.isAuto && !netInfo.isPrivateIpv6Auto && netInfo.privateIpv6"
													class="selected-ellipsis" :title="choosedPrivateIpTitle">
													{{ $t('privateNetInstance.autoShowTip', [netInfo.selectSubnetCidr])
													}}{{ ',' }}{{ privateIpv6Pre + netInfo.privateIpv6 }}
												</p>
												<p v-else-if="netInfo.isAuto && netInfo.isPrivateIpv6Auto"
													class="selected-ellipsis" :title="choosedPrivateIpTitle">
													{{ $t('privateNetInstance.autoShowTip',
														[netInfo.selectSubnetCidr]) }}{{ ',' }}{{
		$t('privateNetInstance.intranetIpv6Tip', [netInfo.selectSubnetIpv6Cidr])
	}}
												</p>
											</template>
										</el-form-item>
										<!--带宽-->
										<el-form-item :label="$t('create.text.bandwidth')">
											<p
												v-if="lineTypes[netInfo.selectedLineType] && netInfo.radioIp == true && netInfo.selectedPaymentType !== 3">
												{{ $t('create.help.byBandwidth', [lineTypes[netInfo.selectedLineType],
												netInfo.selectedMaxBandwidth]) }}
											</p>
											<p
												v-else-if="lineTypes[netInfo.selectedLineType] && netInfo.radioIp == true && netInfo.selectedPaymentType === 3">
												{{ $t('create.help.bySharedBandwidth', [lineTypes[netInfo.selectedLineType],
												netInfo.sharedBandwidthForm.selectBandwidthPackageBandwidth]) }}
											</p>
											<p v-else>--</p>
										</el-form-item>
										<!--已加入共享带宽-->
										<el-form-item :label="$t('create.text.aleadyJoinSharedBandwidth')">
											<p
												v-if="netInfo.radioIp === true && netInfo.selectedPaymentType === 3 && netInfo.sharedBandwidthForm.selectBandwidthPackageName">
												{{ netInfo.sharedBandwidthForm.selectBandwidthPackageName }}{{
													$t('create.help.aleadyJoinSharedBandwidth',
														[netInfo.sharedBandwidthForm.selectBandwidthPackageBandwidth]) }}
											</p>
											<p v-else>--</p>
										</el-form-item>
									</div>
								</div>
								<!--辅网口-->
								<div v-if="selectedNetworkQuantity === 'dual'">
									<h3 class="network-title" @click="collapseSelected('extensionNetInfo')">
										<span>{{ $t('create.text.subInternetAccessName') }}</span>
										<i
											:class="extensionNetInfo.collapseSelected ? 'jc-icon-caret-bottom' : 'jc-icon-caret-top'">
										</i>
									</h3>
									<div v-show="!extensionNetInfo.collapseSelected">
										<!--私有网络-->
										<el-form-item :label="$t('privateNetInstance.privateNet')">
											<p>{{ extensionNetInfo.selectVpcName | maybeEmpty }}</p>
										</el-form-item>
										<!--子网-->
										<el-form-item :label="$t('privateNetInstance.subnet')">
											<p>{{ extensionNetInfo.selectSubnetName | maybeEmpty }}</p>
										</el-form-item>
										<!--内网IP-->
										<el-form-item :label="$t('privateNetInstance.interNetwork')">
											<template v-if="!extensionNetInfo.privateIpv6Visible">
												<p v-if="!extensionNetInfo.isAuto && extensionNetInfo.internetIp !== ''"
													class="selected-ellipsis" :title="extensionNetInfo.internetIp">
													{{ extensionNetInfo.internetIp }}
												</p>
												<p
													v-else-if="!extensionNetInfo.isAuto && extensionNetInfo.internetIp === ''">
													{{ '--' }}
												</p>
												<p v-else>
													{{ $t('privateNetInstance.autoShowTip',
														[extensionNetInfo.selectSubnetCidr]) }}
												</p>
											</template>
											<template v-else>
												<p v-if="!extensionNetInfo.isAuto && extensionNetInfo.internetIp !== '' && extensionNetInfo.isPrivateIpv6Auto"
													class="selected-ellipsis" :title="choosedPrivateIpTitle">
													{{ extensionNetInfo.internetIp }}{{ ',' }}{{
														$t('privateNetInstance.intranetIpv6Tip',
															[extensionNetInfo.selectSubnetIpv6Cidr]) }}
												</p>
												<p v-else-if="!extensionNetInfo.isAuto && extensionNetInfo.internetIp !== '' && !extensionNetInfo.isPrivateIpv6Auto && extensionNetInfo.privateIpv6 !== ''"
													class="selected-ellipsis" :title="choosedPrivateIpTitle">
													{{ extensionNetInfo.internetIp + ',' + extensionPrivateIpv6Pre +
														extensionNetInfo.privateIpv6 }}
												</p>
												<p v-else-if="extensionNetInfo.isAuto && !extensionNetInfo.isPrivateIpv6Auto && extensionNetInfo.privateIpv6"
													class="selected-ellipsis" :title="choosedPrivateIpTitle">
													{{ $t('privateNetInstance.autoShowTip',
														[extensionNetInfo.selectSubnetCidr]) }}{{ ',' }}{{
		extensionPrivateIpv6Pre
		+ extensionNetInfo.privateIpv6 }}
												</p>
												<p v-else-if="extensionNetInfo.isAuto && extensionNetInfo.isPrivateIpv6Auto"
													class="selected-ellipsis" :title="choosedPrivateIpTitle">
													{{ $t('privateNetInstance.autoShowTip',
														[extensionNetInfo.selectSubnetCidr]) }}{{ ',' }}{{
		$t('privateNetInstance.intranetIpv6Tip',
			[extensionNetInfo.selectSubnetIpv6Cidr]) }}
												</p>
											</template>
										</el-form-item>
										<!--带宽-->
										<el-form-item :label="$t('create.text.bandwidth')">
											<p
												v-if="lineTypes[extensionNetInfo.selectedLineType] && extensionNetInfo.radioIp == true && extensionNetInfo.selectedPaymentType !== 3">
												{{ $t('create.help.byBandwidth',
													[lineTypes[extensionNetInfo.selectedLineType],
													extensionNetInfo.selectedMaxBandwidth]) }}
											</p>
											<p
												v-else-if="lineTypes[extensionNetInfo.selectedLineType] && extensionNetInfo.radioIp == true && extensionNetInfo.selectedPaymentType === 3">
												{{ $t('create.help.bySharedBandwidth',
													[lineTypes[extensionNetInfo.selectedLineType],
													extensionNetInfo.sharedBandwidthForm.selectBandwidthPackageBandwidth]) }}
											</p>
											<p v-else>--</p>
										</el-form-item>
										<!--已加入共享带宽-->
										<el-form-item :label="$t('create.text.aleadyJoinSharedBandwidth')">
											<p
												v-if="extensionNetInfo.radioIp === true && extensionNetInfo.selectedPaymentType === 3 && extensionNetInfo.sharedBandwidthForm.selectBandwidthPackageName">
												{{ extensionNetInfo.sharedBandwidthForm.selectBandwidthPackageName }}{{
													$t('create.help.aleadyJoinSharedBandwidth',
														[extensionNetInfo.sharedBandwidthForm.selectBandwidthPackageBandwidth]) }}
											</p>
											<p v-else>--</p>
										</el-form-item>
									</div>
								</div>
								<!--购买时长-->
								<el-form-item v-if="currentMode === 'tab1'" :label="$t('create.text.buySpan')"
									:title="$t('create.text.buyTimeSpan')">
									<p v-if="selectedMonth % 12 != 0">
										{{ selectedMonth }} {{ $tc('create.text.month', selectedMonth) }}
									</p>
									<p v-else-if="selectedMonth % 12 == 0">{{ selectedMonth / 12 }}
										{{ $tc('create.text.yearUnit', selectedMonth / 12) }}
									</p>
									<p v-else>--</p>
								</el-form-item>
								<!--购买数量-->
								<el-form-item :label="$t('create.text.buyNum')">
									<p>{{ selectedHostNumber }}</p>
								</el-form-item>
							</section>
							<!--费用-->
							<section class="selected-cost">
								<h3 class="selected-cost-title">
									{{ $t('create.text.cost') }}</h3>
								<!--包年包月计费-->
								<div v-if="currentMode === 'tab1'">
									<!--服务器-->
									<el-form-item :label="$t('create.text.server')">
										<p class="form-item-nopadding"
											:class="[totalDiscount > 0 ? '' : 'form-item-bottom']">
											<span class="price highlight-font-color">￥{{ discountedServerPrice }}</span>
											<span class="none">{{ calTotalPrice.discountedServerPrice }}</span>
										</p>
									</el-form-item>
									<!--主网口eip-->
									<el-form-item v-if="netInfo.radioIp" :label="$t('create.text.mainEip')">
										<p class="form-item-nopadding"
											:class="[totalDiscount > 0 ? '' : 'form-item-bottom']">
											<span class="price" v-if="netInfo.selectedPaymentType !== 3">￥{{
												discountedMainEipPrice }}</span>
											<span class="price" v-else>
												￥0.00
											</span>
											<span class="none">{{ calTotalPrice.discountedMainEipPrice }}</span>
										</p>
									</el-form-item>
									<!--辅网口eip-->
									<el-form-item v-if="extensionNetInfo.radioIp" :label="$t('create.text.extensionEip')">
										<p class="form-item-nopadding"
											:class="[totalDiscount > 0 ? '' : 'form-item-bottom']">
											<span class="price" v-if="extensionNetInfo.selectedPaymentType !== 3">￥{{
												discountedExtensionEipPrice }}</span>
											<span class="price" v-else>
												￥0.00
											</span>
											<span class="none">{{ calTotalPrice.discountedExtensionEipPrice }}</span>
										</p>
									</el-form-item>
									<save-price v-if="totalDiscount > 0" :totalDiscount="favorablePricePerHour"
										:originPrice="totalPrice"></save-price>
								</div>
								<!--按配置计费-->
								<div v-else>
									<!--服务器-->
									<el-form-item v-if="currentMode === 'tab2'" :label="$t('create.text.server')">
										<p class="form-item-nopadding"
											:class="[configurationTotalDiscount > 0 ? '' : 'form-item-bottom']">
											<span class="price highlight-font-color">
												{{ $t('create.text.feePerHour',
													[discountByConfigurationsServerPriceOneHour]) }}</span>
											<span class="none">{{ calTotalPrice.discountedTotalPrice }}</span>
										</p>
									</el-form-item>
									<!--主网口eip-->
									<el-form-item v-if="netInfo.radioIp" :label="$t('create.text.mainEip')">
										<p class="form-item-nopadding"
											:class="[configurationTotalDiscount > 0 ? '' : 'form-item-bottom']">
											<span class="price" v-if="netInfo.selectedPaymentType !== 3">
												{{ $t('eip.text.feePerHour', [discountByConfigurationsMainEipPriceOneHour])
												}}
											</span>
											<span v-else class="price">
												{{ $t('eip.text.feePerHour', [0.00]) }}
											</span>
											<span class="none">
												{{ configurationCalTotalPrice.discountByConfigurationsMainEipPriceOneHour }}
											</span>
											<span class="none">
												{{ calTotalPrice.discountedTotalPrice }}
											</span>
										</p>
									</el-form-item>
									<!--辅网口eip-->
									<el-form-item :label="$t('create.text.extensionEip')" v-if="extensionNetInfo.radioIp">
										<p class="form-item-nopadding"
											:class="[configurationTotalDiscount > 0 ? '' : 'form-item-bottom']">
											<span class="price" v-if="extensionNetInfo.selectedPaymentType !== 3">
												{{ $t('eip.text.feePerHour',
													[discountByConfigurationsExtensionEipPriceOneHour]) }}
											</span>
											<span class="price" v-else>
												{{ $t('eip.text.feePerHour', [0.00]) }}
											</span>
											<span class="none">
												{{
													configurationCalTotalPrice.discountByConfigurationsExtensionEipPriceOneHour
												}}
											</span>
											<span class="none">
												{{ calTotalPrice.discountedTotalPrice }}
											</span>
										</p>
									</el-form-item>
									<p class="month-total-price">
										<span>{{ $t('create.text.configureMonthPay',
											[discountByConfigurationsOneMonthPrice]) }}</span>
										<span class="none">{{
											configurationCalTotalPrice.discountByConfigurationsOneMonthPrice }}</span>
									</p>
									<save-price v-if="configurationTotalDiscount > 0"
										:totalDiscount="configurationTotalDiscount"
										:originPrice="configurationTotalPrice"></save-price>
								</div>
								<el-button type="primary" size="large" :disabled="!isStockEnough
									|| moreThanAvailableQuota
									|| !selectedStandard
									|| !isCertification
									|| !EipStockIsEnough
									|| !EipQuotaIsEnough" class="my-buy-btn" @click="buy()">{{ isBuyTag }}
								</el-button>
								<p v-if="currentMode === 'tab2'" class="like-form-help-item">
									{{ $t('create.text.yearPackage', [discountedTotalPrice]) }}
								</p>
								<p v-if="!isCertification" class="red mt10">
									{{ $t('create.help.noCertification') }}
									<a :href="Config.REALNAME_URL">
										{{ $t('create.help.goCertificate') }}</a>
								</p>
								<p v-else-if="!isStockEnough" class="red mt10">
									<span v-if="cacheDeviceTypesNum[selectedStandard]">{{ $t('create.help.restock')
									}}</span>
									<span v-else>{{ $t('create.help.soldOut') }}</span>{{ $t('create.help.contact') }}
									<a :href="Config.WORK_URL" target="_blank">{{ $t('create.tooltip.ticket') }}</a>
								</p>
								<p v-else-if="isStockEnough && moreThanAvailableQuota" class="red">
									{{ $t('create.help.CPSOverStock') }}{{ $t('create.help.contact') }}
									<a :href="Config.WORK_URL" target="_blank">{{ $t('create.tooltip.ticket') }}</a>
								</p>
								<p v-else-if="isStockEnough && selectedStandard == ''" class="red mt10">
									<span v-if="cacheDeviceTypesNum[selectedStandard]">{{ $t('create.help.restock')
									}}</span>
									<span v-else>{{ $t('create.help.soldOut') }}</span>{{ $t('create.help.contact') }}
									<a :href="Config.WORK_URL" target="_blank">{{ $t('create.tooltip.ticket') }}</a>
								</p>
								<p v-else-if="isStockEnough && !moreThanAvailableQuota && (netInfo.radioIp || extensionNetInfo.radioIp)"
									class="eip-tip-info">
									<span v-if="eipInfo.available < selectedHostNumber">
										{{ $t('eip.help.soldOut') }}
										<a :href="Config.WORK_URL" target="_blank">
											{{ $t('eip.help.openTicket') }}
										</a>
										<span>{{ $t('eip.help.increaseLimit') }}</span>
									</span>
									<span v-else-if="eipInfo.availableQuota < selectedHostNumber">
										{{ $t('create.help.EipExceedQuota') }}{{ $t('create.help.contact') }}
										<a :href="Config.WORK_URL" target="_blank">
											{{ $t('create.tooltip.ticket') }}
										</a>
									</span>
									<span
										v-else-if="(netInfo.radioIp && extensionNetInfo.radioIp) && eipInfo.availableQuota < selectedHostNumber + 1">
										{{ $t('create.help.EipExceedQuota') }}{{ $t('create.help.contact') }}
										<a :href="Config.WORK_URL" target="_blank">
											{{ $t('create.tooltip.ticket') }}
										</a>
									</span>
								</p>
							</section>
						</el-form>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>


<script>
import VueCookie from 'vue-cookie';
import { cidrList } from '@/common/ConstParam.js';
import { NetworkTypeConstant, CreateTypeConstant, I18nConstant, ServiceCodeConstant, PasswordRuleConstant, BillingTypesConstant, CustomPartitionSupportConstant } from '@/common/Constants';
import cidr from '@/components/common/cidr/Cidr';
import AddAliasIpRange from '@/components/common/addAliasIpRange/AddAliasIpRange';
import CustomPartition from '@/components/common/customPartition/customPartition';
import CustomData from '@/components/common/customData/CustomData';
import SelectBandwidthPackage from '@/components/common/selectBandwidthPackage/SelectBandwidthPackage';
import SavePrice from '@/components/common/SavePrice';
import SecretKey from '@/components/common/secretKey/SecretKey';
import SosSecretKey from '@/components/common/sosSecretKey/SosSecretKey';
import ifCertification from '@/mixins/ifCertification';
import { changeTwoDecimal, deepCopy, isIpv6, guid, mulDecimals, subDecimals, handleAddClassToBody, handleRemoveClassFromBody } from '@/common/tool';
import initSelectedPotision from '@/mixins/initSelectedPotision';
import buyTime from '@/mixins/buyTime';

export default {
	components: {
		cidr,
		AddAliasIpRange,
		CustomPartition,
		CustomData,
		SelectBandwidthPackage,
		SavePrice,
		SecretKey,
		SosSecretKey
	},
	mixins: [ifCertification, initSelectedPotision, buyTime],
	data() {
		const validatePassword = (rule, value, callback) => {
			var rule = PasswordRuleConstant
			const result = rule.test(value);
			if (!result) {
				callback(new Error(this.$t('create.placeholder.passNotMeetRequire')));
				return;
			}
			callback();
		};

		const validateConfirmPassword = (rule, value, callback) => {
			if (value == '') {
				callback(new Error(this.$t('create.placeholder.passNotMeetRequire')));
			} else if (value != this.ruleForm.hostPwd) {
				callback(new Error(this.$t('create.placeholder.passwordNotSame')));
			} else {
				callback();
			}
		};

		const validateHostName = (rule, value, callback) => {
			const reg = /(^((?!(^-)|(-$)|(--+)|(^\\.)|(\\.$)|(\\.\\.+))[0-9A-Za-z-.{}]){2,64}$)|(^\s*$)/;
			if (value != '') {
				const result = reg.test(value);
				if (!result) {
					callback(new Error(this.$t('create.placeholder.hostNameNotRequire')));
					return;
				}
			}
			callback();
		};

		const validateIpAddress = (rule, value, callback) => {
			const reg = /^(10|11|172|192)\.(\d{1,3})\.(\d{1,3})\.(\d{1,3})$/;
			if (!this.netInfo.isAuto) {
				if (value === '') {
					callback(new Error(this.$t('create.placeholder.default')));
				}
				if (!reg.test(value)) {
					callback(new Error(this.$t('create.placeholder.ipAddressNotPass')));
				} else {
					callback();
				}
			} else {
				callback();
			}
		};

		const validateIpv6Address = (rule, value, callback) => {
			const reg = /^\\s*((([0-9A-Fa-f]{1,4}:){7}([0-9A-Fa-f]{1,4}|:))|(([0-9A-Fa-f]{1,4}:){6}(:[0-9A-Fa-f]{1,4}|((25[0-5]|2[0-4]\\d|1\\d\\d|[1-9]?\\d)(\\.(25[0-5]|2[0-4]\\d|1\\d\\d|[1-9]?\\d)){3})|:))|(([0-9A-Fa-f]{1,4}:){5}(((:[0-9A-Fa-f]{1,4}){1,2})|:((25[0-5]|2[0-4]\\d|1\\d\\d|[1-9]?\\d)(\\.(25[0-5]|2[0-4]\\d|1\\d\\d|[1-9]?\\d)){3})|:))|(([0-9A-Fa-f]{1,4}:){4}(((:[0-9A-Fa-f]{1,4}){1,3})|((:[0-9A-Fa-f]{1,4})?:((25[0-5]|2[0-4]\\d|1\\d\\d|[1-9]?\\d)(\\.(25[0-5]|2[0-4]\\d|1\\d\\d|[1-9]?\\d)){3}))|:))|(([0-9A-Fa-f]{1,4}:){3}(((:[0-9A-Fa-f]{1,4}){1,4})|((:[0-9A-Fa-f]{1,4}){0,2}:((25[0-5]|2[0-4]\\d|1\\d\\d|[1-9]?\\d)(\\.(25[0-5]|2[0-4]\\d|1\\d\\d|[1-9]?\\d)){3}))|:))|(([0-9A-Fa-f]{1,4}:){2}(((:[0-9A-Fa-f]{1,4}){1,5})|((:[0-9A-Fa-f]{1,4}){0,3}:((25[0-5]|2[0-4]\\d|1\\d\\d|[1-9]?\\d)(\\.(25[0-5]|2[0-4]\\d|1\\d\\d|[1-9]?\\d)){3}))|:))|(([0-9A-Fa-f]{1,4}:){1}(((:[0-9A-Fa-f]{1,4}){1,6})|((:[0-9A-Fa-f]{1,4}){0,4}:((25[0-5]|2[0-4]\\d|1\\d\\d|[1-9]?\\d)(\\.(25[0-5]|2[0-4]\\d|1\\d\\d|[1-9]?\\d)){3}))|:))|(:(((:[0-9A-Fa-f]{1,4}){1,7})|((:[0-9A-Fa-f]{1,4}){0,5}:((25[0-5]|2[0-4]\\d|1\\d\\d|[1-9]?\\d)(\\.(25[0-5]|2[0-4]\\d|1\\d\\d|[1-9]?\\d)){3}))|:)))(%.+)?\\s*$/;
			if (!this.netInfo.isPrivateIpv6Auto) {
				let ipv6 = this.privateIpv6Pre + this.netInfo.privateIpv6;
				if (value === '') {
					callback(new Error(this.$t('create.placeholder.default')));
				}
				if (!isIpv6(ipv6)) {
					callback(new Error(this.$t('create.placeholder.ipv6AddressNotPass')));
				} else {
					callback();
				}
			}
			if (!this.extensionNetInfo.isPrivateIpv6Auto) {
				let ipv6 = this.extensionPrivateIpv6Pre + this.extensionNetInfo.privateIpv6;
				if (value === '') {
					callback(new Error(this.$t('create.placeholder.default')));
				}
				if (!isIpv6(ipv6)) {
					callback(new Error(this.$t('create.placeholder.ipv6AddressNotPass')));
				} else {
					callback();
				}
			}
			callback();
		};

		// 验证加入共享带宽计费模式是否选择共享带宽
		const validateSelectBandwidthPackage = (rule, value, callback) => {
			if (this.netInfo.radioIp) {
				if (this.netInfo.selectedPaymentType === 3) {
					if (!this.netInfo.sharedBandwidthForm.selectBandwidthPackage) {
						callback(new Error(this.$t('create.placeholder.default')));
					} else {
						callback()
					}
				} else {
					callback()
				}
			}
			if (this.extensionNetInfo.radioIp) {
				if (this.extensionNetInfo.selectedPaymentType === 3) {
					if (!this.extensionNetInfo.sharedBandwidthForm.selectBandwidthPackage) {
						callback(new Error(this.$t('create.placeholder.default')));
					} else {
						callback()
					}
				} else {
					callback()
				}
			}
			callback()

		};
		const standardImage = this.$t('create.text.standardImage');
		const standardAppImage = this.$t('create.text.standardAppImage');

		return {
            privateNetInstanceVpcLoading: false, // @ZTT 主网口私有网络下拉列表加载
            privateNetInstanceExVpcLoading: false, // @ZT 辅网口私有网络下拉列表加载
			gameCreateUrl: "", // 点击创建资源，跳转到创建游戏服务器页面
			spcTypeName: "", // 规格类型，用于组合校验是否为游戏服务器，显示红字提示
			currentMode: 'tab1',
			isVip: false, // 是否为大客户(true: 是)
			// 高级设置内容，已base64过
			userData: '',
			// 高级设置是否选中
			advancedSetting: false,
			tagForm: {
				tags: []
			},
			tagRules: {

			},
			// 设置密码选中的类型
			passwordType: 'custom',
			eipInfo: {
				availableQuota: 0,
				userQuota: 0,
				available: 0
			},
			networkInfoRules: {
				selectVpcId: [
					{
						required: true,
						message: this.$t('privateNetInstance.empty'),
						trigger: 'change'
					}
				],
				selectSubnetId: [
					{
						required: true,
						message: this.$t('privateNetInstance.empty'),
						trigger: 'change'
					}
				],
				internetIp: [
					{
						validator: validateIpAddress,
						trigger: 'blur'
					}
				],
				privateIpv6: [
					{

						validator: validateIpv6Address,
						trigger: 'blur'
					}
				],
				selectBandwidthPackage: [
					{
						validator: validateSelectBandwidthPackage,
						message: this.$t('privateNetInstance.empty'),
						trigger: 'change'
					}
				]
			},
			netInfo: {
				vpcCount: 0,
				subnetCount: 0,
				vpcList: [],
				subnetList: [],
				selectVpcId: '',
				selectVpcName: '',
				selectVpcCidr: '',
				selectVpcIpv6Cidr: '',
				selectSubnetId: '',
				selectSubnetName: '',
				selectSubnetCidr: '',
				selectSubnetIpv6Cidr: '',
				isAuto: 1,
				internetIp: '',
				privateIpv6Visible: false,
				isPrivateIpv6Auto: 1,
				selectedPaymentType: 1,
				sharedBandwidthForm: {
					selectBandwidthPackage: '',
					selectBandwidthPackageName: '',
					selectBandwidthPackageBandwidth: ''
				},
				selectedLineType: 'bgp',
				privateIpv6: '',
				ipOperations: [
					{
						value: 1,
						label: this.$t('privateNetInstance.auto')
					},
					{
						value: 0,
						label: this.$t('privateNetInstance.handwrite')
					}
				],
				radioIp: true,
				tmpMaxBandwidth: 1,
				selectedMaxBandwidth: 1,
				collapseSelected: true,
			},
			extensionNetInfo: {
				vpcCount: 0,
				subnetCount: 0,
				vpcList: [],
				subnetList: [],
				selectVpcId: '',
				selectVpcName: '',
				selectVpcCidr: '',
				selectSubnetId: '',
				selectSubnetName: '',
				selectSubnetCidr: '--',
				selectSubnetIpv6Cidr: '',
				isAuto: 1,
				internetIp: '',
				privateIpv6Visible: false,
				isPrivateIpv6Auto: 1,
				selectedPaymentType: 1,
				sharedBandwidthForm: {
					selectBandwidthPackage: '',
					selectBandwidthPackageName: '',
					selectBandwidthPackageBandwidth: ''
				},
				selectedLineType: 'bgp',
				privateIpv6: '',
				ipOperations: [
					{
						value: 1,
						label: this.$t('privateNetInstance.auto')
					},
					{
						value: 0,
						label: this.$t('privateNetInstance.handwrite')
					}
				],
				radioIp: false,
				tmpMaxBandwidth: 1,
				selectedMaxBandwidth: 1,
				collapseSelected: true
			},
			//能够添加的最大的别名IP数
			maxAliasIpCount: 50,
			firewall: '',
			quotaNumber: 0,
			cidr_map: {
				cidrMap: {
					16: 65534,
					17: 32766,
					18: 16382,
					19: 8190,
					20: 4094,
					21: 2046,
					22: 1022,
					23: 510,
					24: 254,
					25: 126,
					26: 62,
					27: 30,
					28: 14,
				}
			},
			ruleFormType: {
				type: this.selectedOSTypeId,
				application: this.selectedApplication
			},
			// 区域
			selectedRegion: '',
			selectedZone: '',
			// 规格
			selectedStandard: '',
			selectedStandardName: '',
			deviceCustomPartitionSupport: true,
			//查询规格
			searchType: '',
			// 镜像
			selectedImageType: 0,
			selectedOS: '',
			selectedOSTypeId: '',
			isCentOS66: false,
			selectedApplication: [],
			// 存储
			selectedSysRaidName: '',
			selectedSysRaidTip: '',
			sysDiskCapacity: '',
			dataDiskCapacity: '',
			systemDiskPartitionModes: [
				{ id: 1, label: this.$t('create.text.defaultPartitionModes'), value: 'default' },
				{ id: 2, label: this.$t('create.text.customPartitionModes'), value: 'custom' },
			],
			selectedPartitionMode: 'default',
			defaultSystemDataPartitions: '',
			systemDataCustomPartitionVisible: false,
			systemDataPartitions: [],
			systemDiskSize: 0,
			dataDiskPartitionModes: [
				{ id: 1, label: this.$t('create.text.defaultPartitionModes'), value: 'default' },
				{ id: 2, label: this.$t('create.text.customPartitionModes'), value: 'custom' },
			],
			selectedDataDiskPartitionMode: 'default',
			defaultDataDiskPartitions: '',
			dataDiskPartitions: [],
			dataDiskSize: 0,
			selectedDataRaid: {},
			selectedDataRaidName: '',
			selectedOSRaidId: '',
			selectedDataRaidId: '',
			stockEnough: false,
			// 网络数量与名称
			selectedNetworkQuantity: 'bond',
			networkQuantity: [
				{ id: 1, label: this.$t('create.text.singleInternetAccess'), value: 'bond' },
				{ id: 2, label: this.$t('create.text.doubleInternetAccess'), value: 'dual' },
			],
			// 带宽计费模式
			bandwidthPaymentTypes: [
			],
			// 主网口添加别名IP范围组件是否显示
			addAliasIpRangeVisible: false,
			// 辅网口添加别名IP范围组件是否显示
			extensionAddAliasIpRangeVisible: false,
			// 主网口选中子网详情
			selectedSubnetDetail: {},
			// 辅网口选中子网详情
			selectedExtensionSubnetDetail: {},
			// 添加的别名IP数据
			aliasIpData: [],
			// 辅网口添加的别名IP数据
			extensionAliasIpData: [],
			// 基本信息
			hostName: '',
			hostDesc: '',
			hostUserName: 'root',
			hostPwd: '',
			hostConfirmPwd: '',
			// 购买数量
			selectedMonth: 1,
			cutMonth: 0,
			selectedHostNumber: 1,
			maxHostNumber: 5,
			// 实名认证
			isBuyTag: this.$t('create.text.buyNow'),
			// 库存
			isStockEnough: true,
			// 包年包月价格
			isCalculatIng: false, // 包年包月计费中
			discountedTotalPrice: '--',
			discountedServerPrice: '--',
			discountedMainEipPrice: '--',
			discountedExtensionEipPrice: '--',
			totalPrice: 0,
			totalDiscount: 0,
			// 按配置价格
			isConfigurationsCalculatIng: false, // 按配置计费中
			discountByConfigurationsTotalPrice: '--',
			discountByConfigurationsOneMonthPrice: '--',
			discountByConfigurationsServerPriceOneHour: '--',
			discountByConfigurationsMainEipPriceOneHour: '--',
			discountByConfigurationsExtensionEipPriceOneHour: '--',
			configurationTotalPrice: '--', // 按配置计价总费用
			configurationTotalDiscount: '--', // 按配置计价折扣额
			// 页面参数选择
			regions: {},
			zones: { '': {} },
			deviceTypes: {},
			// 不同规格类型的库存数量
			deviceTypesNum: {},
			cacheDeviceTypesNum: {},
			// 用于页面倒叙展示规格
			deviceTypesArr: [],
			imageTypes: [],
			osTypes: {},
			standardOsTypes: {},
			customOsTypes: {},
			applications: [],
			otherMonth: 0,
			raids: [],
			firewalls: [
				{ id: 1, name: this.$t('create.help.firewall') },
				{ id: 2, name: this.$t('create.help.publicOpen') }
			],
			lineTypes: {},
			// 数据盘提示列表
			radisNameMap: {
				NORAID: 'NO RAID',
				RAID0: 'RAID0',
				RAID1: 'RAID1',
				RAID10: 'RAID10',
				RAID5: 'RAID5',
				RAID51H: 'RAID 5+1 hotspare+NO RAID'
			},
			customRaidsNameMap: {
				RAID51H: 'RAID 5+1 hotspare',
				NORAID: 'NO RAID'
			},
			//ssh密钥
			setKeyState: true,
			// 表单验证
			ruleForm: {
				hostName: '',
				hostDesc: '',
				hostPwd: '',
				hostConfirmPwd: '',
				mainName: '',
				publicKey: [], // 密钥对
				selectKey: '', // 选中的密钥对
				sosKey: '', // sos密钥对
			},
			ruleFormTag: {
				hostName: 0,
				hostDesc: 0,
				hostPwd: 0,
				hostConfirmPwd: 0,
				application: 0,
			},
			rulesType: {
				type: [
					{
						required: true,
						message: this.$t('privateNetInstance.empty'),
						trigger: 'change'
					}
				]
			},
			rules: {
				hostName: [
					{
						type: 'string',
						pattern: new RegExp('^[a-zA-Z\\\u4e00-\\\u9fa5]([0-9a-zA-Z\\\u4e00-\\\u9fa5-_.:{}]{1,127})$'),
						trigger: 'blur'
					}
				],
				hostDesc: [
					{ type: 'string', pattern: new RegExp('^.{0,256}$'), trigger: 'blur' }
				],
				hostPwd: [
					{ validator: validatePassword, trigger: 'blur' }
				],
				hostConfirmPwd: [
					{ validator: validateConfirmPassword, trigger: 'blur' }
				],
				mainName: [
					{ validator: validateHostName, trigger: 'blur' }
				],
				selectKey: [
					{ required: true, message: this.$t('privateNetInstance.emptyKeyPair'),  trigger: 'change' }
				],
				sosKey: [
					{ required: true, trigger: 'change' }
				]
			},
			timeUnit: 3,
			chargeUnit: 3, // 月 计费时长单位 1:小时 2:天 3:月 4:年,
			selectedYear: 1, // 选择年份,
			autoRenew: false,//自动续费
			allSold: true,
			deviceTypesTable: [], // 系列对应的机型列表数据
			deviceTypesTableData: [],
			deviceTypesTableData1: [],
			deviceTypesTableData2: [],
			selectedSeries: 'compute', // 所选系列，默认选择计算型,
			seriesMap: {
				// 系列对应的中文名称
				compute: this.$t('create.text.computeType'),
				storage: this.$t('create.text.storageType'),
				gpu: this.$t('create.text.gpuType')
			},
			// 折扣信息
			discountedInfo: [
				{ message: '' },
				{ message: '' },
				{ message: '' }
			],
			// 0折用户折扣信息
			allDiscountedInfo: [
				{ message: [] },
				{ message: [] },
				{ message: [] },
				{ message: [] },
				{ message: [] },
				{ message: [] },
				{ message: [] },
				{ message: [] },
				{ message: [] },
				{ message: [] },
				{ message: [] },
				{ message: [] },
			],
			// 前9个月
			firstNine: [1, 2, 3, 4, 5, 6, 7, 8, 9],
			// 后三年
			lastThree: [1, 2, 3],
			// 默认选中第四个raid的机型（这两个机型的第四个raid都是raid10）
			defaultForthRaidDeviceTypes: [
				'cps.c.perf2', // 计算效能型II
				'cps.s2.normal'// 标准存储型（二代）
			],
			// 默认选中第三个raid的机型
			defaultThirdRaidDeviceTypes: [
				'cps.c.normal', // 标准计算型（默认raid1）
				'cps.gpu.1', // GPU I（默认raid10）
				'cps.gpu.2', // GPU II（默认raid10）
				'cps.gpu.3', // GPU III（默认raid10）
			],
			//带宽上限的上限和下限
			marks: { 1: '1Mbps', 200: '200Mbps' },
			// 规格类型 && 规格
			spcTypeNameList: [
				'游戏高配型',
				'游戏标准型',
				'cps.pc.1rtx40.normal9',
				'cps.pc.1rtx40.high9',
			],
			// 系统版本，包含国际化
			selectedOSNameList: [
				'黑神话悟空',
				'Windows 11 Black-Wukong', // 国际化
			],
            favorablePricePerHour: '--', // // 省 = 原价 - 应付
            showOsTypes: false,
            isWindowsArr: ['Windows', 'WindowsPC'],
		};
	},
	computed: {
		/**
		 * 选择cps.pc.1rtx40.normal9/cps.pc.1rtx40.high9 规格 && 游戏高配型/游戏标准型 && Windows系统
		 * 系统版本选择 黑神话悟空，提示红字：为了获得更好的游戏体验，请到游戏服务器页面 创建资源
		 * 上面话术中的 创建资源 篮字，点击跳转到创建游戏服务器页面
		 */
		isGameServer() {
			/**
			 * selectedOS: 操作系统
			 * selectedOSName: 系统版本
			 * selectedStandard: 游戏服务器显卡规格
			 * spcTypeName: 规格类型
			 */
			if (this.selectedOS?.includes("WindowsPC") &&
			(this.selectedOSNameList?.includes(this.selectedOSName) &&
			(this.spcTypeNameList?.includes(this.selectedStandard)) &&
			this.spcTypeNameList?.includes(this.spcTypeName))) {
				this.gameCreateUrl = `${this.Config.RETURN_URL}/instance/game/create?region=${this.selectedRegion}`;
				console.log("创建游戏服务页面链接>>>", this.gameCreateUrl);
				return true
			}
		},
		systemType() {
			// return this.selectedOS === 'Windows' ? 'windows' : 'linux';
			return this.isWindowsArr.includes(this.selectedOS) ? 'windows' : 'linux';
		},
		// 还可添加多少个IPv4别名IP
		aliasIpRestNumber() {
			return function (type) {
				let cidrCount = 0;
				for (var i = 0; i < this.aliasIpData.length; i++) {
					if (this.aliasIpData[i].cidr !== '') {
						cidrCount++;
					}
				};
				let extensionCidrCount = 0;
				for (var i = 0; i < this.extensionAliasIpData.length; i++) {
					if (this.extensionAliasIpData[i].cidr !== '') {
						extensionCidrCount++;
					}
				};
				let iCount = 0;
				if (type === 'netInfo') {
					if (this.$refs.addAliasIpRange && this.$refs.addAliasIpRange.isRowNotSaved && (this.aliasIpData[this.aliasIpData.length - 1].cidr)) {
						iCount = this.maxAliasIpCount - cidrCount + 1;
					} else {
						iCount = this.maxAliasIpCount - cidrCount;
					}
				} else if (type === 'extensionNetInfo') {
					if (this.$refs.extensionAddAliasIpRange && this.$refs.extensionAddAliasIpRange.isRowNotSaved && (this.extensionAliasIpData[this.extensionAliasIpData.length - 1].cidr)) {
						iCount = this.maxAliasIpCount - extensionCidrCount + 1;
					} else {
						iCount = this.maxAliasIpCount - extensionCidrCount;
					}
				}
				return iCount > 0 ? iCount : 0
			}
		},
		// 还可添加多少个IPv6别名IP
		aliasIpv6RestNumber() {
			return function (type) {
				let ipv6CidrCount = 0;
				for (var i = 0; i < this.aliasIpData.length; i++) {
					if (this.aliasIpData[i].ipv6Cidr !== '') {
						ipv6CidrCount++;
					}
				};
				let extensionIpv6CidrCount = 0;
				for (var i = 0; i < this.extensionAliasIpData.length; i++) {
					if (this.extensionAliasIpData[i].ipv6Cidr !== '') {
						extensionIpv6CidrCount++;
					}
				};
				let ipv6Count = 0;
				if (type === 'netInfo') {
					if (this.$refs.addAliasIpRange && this.$refs.addAliasIpRange.isRowNotSaved && (this.aliasIpData[this.aliasIpData.length - 1].ipv6Cidr)) {
						ipv6Count = this.maxAliasIpCount - ipv6CidrCount + 1;
					} else {
						ipv6Count = this.maxAliasIpCount - ipv6CidrCount;
					}
				} else if (type === 'extensionNetInfo') {
					if (this.$refs.extensionAddAliasIpRange && this.$refs.extensionAddAliasIpRange.isRowNotSaved && (this.extensionAliasIpData[this.extensionAliasIpData.length - 1].ipv6Cidr)) {
						ipv6Count = this.maxAliasIpCount - extensionIpv6CidrCount + 1;
					} else {
						ipv6Count = this.maxAliasIpCount - extensionIpv6CidrCount;
					}
				}
				return ipv6Count > 0 ? ipv6Count : 0
			}
		},
		selectedOSName() {
			if (this.selectedOS && this.selectedOSTypeId) {
				for (const i in this.osTypes[this.selectedOS]) {
					if (this.osTypes[this.selectedOS][i].osTypeId == this.selectedOSTypeId) {
						return this.osTypes[this.selectedOS][i].osName;
					}
				}
			}
			return '';
		},
		/**
		  * 包年包月计算
		  */
		calTotalPrice() {
			return this.calculateTotalPrice();
		},
		/**
		* 按配置计算
		*/
		configurationCalTotalPrice() {
			return this.configurationsCalculateTotalPrice();
		},
		ServiceCodeConstant: () => ServiceCodeConstant,
		/**
		* @return {boolean}
		*/
		EipStockIsEnough() {
			let eipStockIsEnough = true;
			if (this.netInfo.radioIp) {
				eipStockIsEnough = this.isStockEnough
					&& this.quotaNumber
					&& this.selectedHostNumber <= this.eipInfo.available;
			}
			if (this.extensionNetInfo.radioIp) {
				eipStockIsEnough = this.isStockEnough
					&& this.quotaNumber
					&& this.selectedHostNumber <= this.eipInfo.available;
			}
			if (this.netInfo.radioIp && this.extensionNetInfo.radioIp) {
				eipStockIsEnough = this.isStockEnough
					&& this.quotaNumber
					&& this.selectedHostNumber * 2 <= this.eipInfo.available;
			}
			return eipStockIsEnough;
		},
		/**
		* @return {boolean}
		*/
		EipQuotaIsEnough() {
			let eipQuotaIsEnough = true;
			if (this.netInfo.radioIp) {
				eipQuotaIsEnough = this.isStockEnough
					&& this.quotaNumber
					&& this.selectedHostNumber <= this.eipInfo.availableQuota;
			}
			if (this.extensionNetInfo.radioIp) {
				eipQuotaIsEnough = this.isStockEnough
					&& this.quotaNumber
					&& this.selectedHostNumber <= this.eipInfo.availableQuota;
			}
			if (this.netInfo.radioIp && this.extensionNetInfo.radioIp) {
				eipQuotaIsEnough = this.isStockEnough
					&& this.quotaNumber
					&& this.selectedHostNumber * 2 <= this.eipInfo.availableQuota;
			}
			return eipQuotaIsEnough;
		},
		moreThanAvailableQuota() {
			return this.quotaNumber < this.selectedHostNumber;
		},
        // @ZTT 主网口私有网络下拉选择
		vpcShowList() {
            this.privateNetInstanceExVpcLoading = true;
			if (this.netInfo.vpcList.length > 0) {
				this.netInfo.vpcList = this.netInfo.vpcList.map(vpc => ({
					vpcId: vpc.vpcId,
					showName: `${vpc.name}(${vpc.vpcId})`,
					name: vpc.name,
					cidr: vpc.cidr,
					ipv6Cidr: vpc.ipv6Cidr
				}));
			}
			return this.netInfo.vpcList;
		},
        // @ZTT 符网口私有网络下拉选项
		extionsVpcShowList() {
            this.privateNetInstanceVpcLoading = true;
			if (this.extensionNetInfo.vpcList.length > 0) {
				this.extensionNetInfo.vpcList = this.extensionNetInfo.vpcList.map(vpc => ({
					vpcId: vpc.vpcId,
					showName: `${vpc.name}(${vpc.vpcId})`,
					name: vpc.name,
					cidr: vpc.cidr,
					ipv6Cidr: vpc.ipv6Cidr
				}));
			}
			return this.extensionNetInfo.vpcList;
		},
		subnetShowList() {
			if (this.netInfo.subnetList.length) {
				this.netInfo.subnetList = this.netInfo.subnetList.map(subnet => ({
					subnetId: subnet.subnetId,
					name: subnet.name,
					showName: `${subnet.name}(${subnet.subnetId})`,
					cidr: subnet.cidr,
					ipv6Cidr: subnet.ipv6Cidr,
					primaryCidr: subnet.cidr,
					region: subnet.region
				}));
			}
			return this.netInfo.subnetList;
		},
		extensionsubnetShowList() {
			if (this.extensionNetInfo.subnetList.length) {
				this.extensionNetInfo.subnetList = this.extensionNetInfo.subnetList.map(subnet => ({
					subnetId: subnet.subnetId,
					name: subnet.name,
					showName: `${subnet.name}(${subnet.subnetId})`,
					cidr: subnet.cidr,
					ipv6Cidr: subnet.ipv6Cidr,
					primaryCidr: subnet.cidr,
					region: subnet.region
				}));
			}
			return this.extensionNetInfo.subnetList;
		},
		currentDeviceType() {
			return this.selectedStandard;
		},
		currentDeviceTypeDetail() {
			if (this.deviceTypes[this.selectedStandard]) {
				return `(${this.deviceTypes[this.selectedStandard].name} ,${this.deviceTypes[this.selectedStandard].cpuConcise} ${this.deviceTypes[this.selectedStandard].memConcise})`;
			}
		},

		privateIpv6Pre() {
			let selectSubnetIpv6Cidr = this.netInfo.selectSubnetIpv6Cidr;
			if (selectSubnetIpv6Cidr) {
				return selectSubnetIpv6Cidr.split('::')[0] + ':'
			}
		},

		extensionPrivateIpv6Pre() {
			let selectSubnetIpv6Cidr = this.extensionNetInfo.selectSubnetIpv6Cidr;
			if (selectSubnetIpv6Cidr) {
				return selectSubnetIpv6Cidr.split('::')[0] + ':'
			}
		},
		/**
		 * 密钥对下拉列表
		 * @return array
		 */
		keyShowList() {
			if (this.ruleForm.publicKey.length) {
				return this.ruleForm.publicKey.map(key => ({
					keypairId: key.keypairId,
					name: key.name,
					publicKey: key.publicKey
				}));
			}
		},

		/**
		 **@disc: 主网口别名IP数据格式化
		 */
		formattedAliasIpTableData() {
			const tempArray = [];
			if (this.aliasIpData.length >= 1) {
				for (const item of this.aliasIpData) {
					if (item.subnetObject && item.cidr && !item.isEditing) {
						tempArray.push({
							id: item.subnetObject.sid,
							cidr: item.cidr,
							scope: 'ipv4'
						})
					}
				}
			}
			return tempArray
		},

		/**
		 **@disc: 主网口别名IPv6数据格式化
		 */
		formattedIpv6TableData() {
			const tempArray = [];
			if (this.aliasIpData.length >= 1) {
				for (const item of this.aliasIpData) {
					if (item.subnetObject && item.ipv6Cidr && !item.isEditing) {
						tempArray.push({
							id: item.subnetObject.sid,
							cidr: item.subnetObject.ipv6Str + ':' + item.ipv6Cidr + '/' + item.lastIpv6Cidr,
							scope: 'ipv6'
						})
					}
				}
			}
			return tempArray
		},

		/**
		 **@disc: 辅网口别名IP数据格式化
		*/
		formattedExtensionAliasIpTableData() {
			const tempArray = [];
			if (this.extensionAliasIpData.length >= 1) {
				for (const item of this.extensionAliasIpData) {
					if (item.subnetObject && item.cidr && !item.isEditing) {
						tempArray.push({
							id: item.subnetObject.sid,
							cidr: item.cidr,
							scope: 'ipv4'
						})
					}
				}
			}
			return tempArray
		},

		/**
		 **@disc: 辅网口别名IPv6数据格式化
		*/
		formattedExtensionIpv6TableData() {
			const tempArray = [];
			if (this.extensionAliasIpData.length >= 1) {
				for (const item of this.extensionAliasIpData) {
					if (item.subnetObject && item.ipv6Cidr && !item.isEditing) {
						tempArray.push({
							id: item.subnetObject.sid,
							cidr: item.subnetObject.ipv6Str + ':' + item.ipv6Cidr + '/' + item.lastIpv6Cidr,
							scope: 'ipv6'
						})
					}
				}
			}
			return tempArray
		},
		/**
			主网口已选配置内网IP hover提示
		*/
		choosedPrivateIpTitle() {
			if (!this.netInfo.isAuto && this.netInfo.internetIp !== '' && this.netInfo.isPrivateIpv6Auto) {
				return this.netInfo.internetIp + ',' + this.$t('privateNetInstance.intranetIpv6Tip', [this.netInfo.selectSubnetIpv6Cidr])
			} else if (!this.netInfo.isAuto && this.netInfo.internetIp !== '' && !this.netInfo.isPrivateIpv6Auto && this.netInfo.privateIpv6 !== '') {
				return this.netInfo.internetIp + ',' + this.privateIpv6Pre + this.netInfo.privateIpv6
			} else if (this.netInfo.isAuto && !this.netInfo.isPrivateIpv6Auto && this.netInfo.privateIpv6) {
				return this.$t('privateNetInstance.autoShowTip', [this.netInfo.selectSubnetCidr]) + ',' + this.privateIpv6Pre + this.netInfo.privateIpv6
			} else if (this.netInfo.isAuto && this.netInfo.isPrivateIpv6Auto) {
				return this.$t('privateNetInstance.autoShowTip', [this.netInfo.selectSubnetCidr]) + ',' + this.$t('privateNetInstance.intranetIpv6Tip', [this.netInfo.selectSubnetIpv6Cidr])
			}
		}

	},
	watch: {
		/**
		 * 设置密码类型改变时，初始化密码和确认密码内容及校验
		 * 暂定为watch，找不到@change可用
		 * @param newVal
		 */
		passwordType() {
			this.$refs.ruleForm.clearValidate(['hostPwd', 'hostConfirmPwd', 'selectKey']);
			this.ruleForm.hostPwd = '';
			this.ruleForm.hostConfirmPwd = '';
			this.ruleForm.selectKey = '';
			this.ruleFormTag.hostPwd = 0;
			this.ruleFormTag.hostConfirmPwd = 0;
		},

		setKeyState() {
			this.$refs.ruleForm.clearValidate(['selectKey']);
			this.ruleForm.selectKey = '';
		},
		selectedRegion(newValue, oldVlue) {
			if (newValue) {
				if (this.zones[this.selectedRegion]) {
					for (const az in this.zones[this.selectedRegion]) {
						this.selectedZone = az;
						break;
					}
				} else {
					this.selectedZone = '';
				}
				this.getUserType();
				this.getDeviceType();
				this.getQuota();
				this.getVpcCount();
				this.getDiscountInfo();
				this.getEipQuota();
				this.getEipStock();
				this.getLineTypes();
				this.selectedStandard = '';
				this.spcTypeName = '';
			}
		},
		deviceTypesNum(newValue, oldVlue) {
			const flag = false;
			if (newValue === 1) {
				for (const key in newValue) {
					if (newValue[key]) {
						this.flag = true;
					}
				}
				this.stockEnough = flag;
			}
		},
		selectedZone(newValue, oldVlue) {
			if (newValue) {
				this.getQuota();
				this.getDeviceType();
				// this.selectedSeries = 'compute';
				this.selectedStandard = '';
				this.spcTypeName = '';
				this.cidr2Val = 0;
				this.cidr3Val = 0;
				this.cidr4Val = 0;
			}
		},
		selectedSeries(val) {
			if (val) {
				this.searchType = '';
				// 历史逻辑：先清空selectedStandard再回填，会重复触发selectedStandard赋值
				// this.selectedStandard = '';
                // this.selectedOS = '';
                this.selectedOS = Object.keys(this.osTypes)?.[0] || ''; // 切换“系列”时，将“镜像”的“操作系统”置为第一个
				this.osTypes[this.selectedOS] = [];
				this.handleIconClick();
			}
			this.initSelectedStandardBySeries(this.selectedSeries);
		},
		selectedStandard(newValue, oldVlue) {
			if (newValue == '') {
				this.selectedStandardName = '';
			} else if (this.deviceTypes[newValue] != undefined) {
				this.selectedStandardName = `${this.selectedStandard
					}(${this.deviceTypes[newValue].cpuDetail} ${this.deviceTypes[newValue].memDetail},${this.deviceTypes[newValue].name})`;
				this.getAvailableOS(this.selectedImageType);
				this.getAvailableRaids(newValue);
				this.checkStockEnough(this.selectedRegion, this.selectedZone, newValue, this.selectedHostNumber);

				let customPartitionSupport = this.deviceTypes[newValue].customPartitionSupport
				this.deviceCustomPartitionSupport = CustomPartitionSupportConstant[customPartitionSupport];
				this.resetPartitionModes(this.deviceCustomPartitionSupport);
                this.showOsTypes = true;
			}
			this.selectedOSTypeId = '';
		},
		selectedOS(newValue, oldValue) {
			this.$refs.osVersion.resetField();
			this.selectedOSTypeId = '';

            // 重置为默认分区后，清空自定义分区数据
            this.systemDataPartitions = []; // 系统盘
            this.dataDiskPartitions = []; // 数据盘
            this.selectedPartitionMode = 'default';
			this.selectedDataDiskPartitionMode = 'default';

			// if (newValue === "Windows" || newValue === "WindowsPC") {
			// 	this.setKeyState = false;
			// }
            if (this.isWindowsArr.includes(newValue)) {
				this.setKeyState = false;
			}

		},
		selectedOSTypeId(newValue, oldVlue) {
			this.ruleFormType.type = newValue;
			this.selectedApplication = [];
			if (!newValue) {
				return
			}
			let customPartitionSupport = this.deviceCustomPartitionSupport;
			let isQcow2 = this.osTypes[this.selectedOS].filter(item => item.osTypeId === newValue).every(item => item.osFormat === 'qcow2');
			this.resetPartitionModes(customPartitionSupport && !isQcow2);
			this.resetDataPartitionModes(this.selectedDataRaid);
			this.getOSPartitions();
		},
		selectedOSName(newValue, oldValue) {
			let spaceReg = /\s+/g;
			let osName = newValue.split(spaceReg).splice(0, 2).join(' ');
			// CentOS 6.6自定义分区文件系统特殊处理标识
			if (osName === 'CentOS 6.6') {
				this.isCentOS66 = true;
			} else {
				this.isCentOS66 = false;
			}

		},
		selectedImageType(newValue, oldVlue) {
			if (newValue !== 'standard_app') {
				this.osTypes = $.extend(true, {}, this.standardOsTypes);
			} else {
				this.selectedOS = 'CentOS';
				this.osTypes = $.extend(true, {}, this.customOsTypes);
			}
			if (newValue == 'standard_app' && this.selectedRegion && this.selectedOS === 'CentOS') {
				// this.getAvailableOSSoftwares()
			}
			this.getAvailableOS(this.selectedImageType);
			this.$refs.osVersion.resetField();
			this.selectedOSTypeId = '';
			this.selectedApplication = [];
		},
		selectedApplication(newValue, oldVlue) {
			this.ruleFormType.application = newValue;
			if (newValue.length) {
				this.ruleFormTag.application = 0;
			}
		},
		selectedPartitionMode(newValue, oldVlue) {
			if (newValue === 'default') {
                // 重置为默认分区后，清空 系统盘 自定义分区数据
                this.systemDataPartitions = [];
				this.resetDiskCapacity('system');
			}
		},
		selectedDataDiskPartitionMode(newValue, oldVlue) {
			if (newValue === 'default') {
                // 重置为默认分区后，清空 数据盘 自定义分区数据
                this.dataDiskPartitions = []; // 数据盘
				this.resetDiskCapacity('data');
			}
		},
		// 切换后面数量的时候，要查一下库存，是否满足当前数量
		selectedHostNumber(newValue, oldVlue) {
			for (let i = 0; i < this.deviceTypesArr.length; i++) {
				this.checkStockEnough(this.selectedRegion, this.selectedZone, this.deviceTypesArr[i].deviceType, newValue);
			}
		},
		'netInfo.isAuto': function (newVal) {
			if (newVal === 0) {
				this.selectedHostNumber = 1;
			}
		},
		selectedNetworkQuantity(newVal) {
            // 切换网口后，清空已选的私有网络
            this.netInfo.selectVpcId = '';
			this.netInfo.selectSubnetId = '';
			this.extensionNetInfo.selectVpcId = '';
			this.extensionNetInfo.selectSubnetId = '';

            // @ZTT
            this.extensionNetInfo.selectVpcCidr = '';
            this.netInfo.selectVpcCidr  = '';
			if (newVal === 'bond') {
				this.$refs.networkInfo.resetFields(['selectVpcId', 'selectSubnetId']);
				this.$refs.extensionNetInfo.resetFields(['selectVpcId', 'selectSubnetId']);
				this.netInfo.subnetCount = 0;
				this.extensionNetInfo.subnetCount = 0;
				this.extensionNetInfo.radioIp = false;
				this.getVpcCount('netInfo')
			} else {
				this.$refs.networkInfo.resetFields(['selectVpcId', 'selectSubnetId']);
				this.netInfo.subnetCount = 0;
				this.extensionNetInfo.subnetCount = 0;
				this.extensionNetInfo.radioIp = true;
				this.getVpcCount('netInfo')
				this.getVpcCount('extensionNetInfo')
			}
		},
	},
	created() {
		this.getQuota();
		this.getRegion();
	},
    mounted() {
        handleAddClassToBody('body-overflow-hidden') // 当小屏幕下，下拉选择项出现时， 防止页面出现滚动条
    },
    beforeDestroy() {
        handleRemoveClassFromBody('body-overflow-hidden')
    },
	methods: {
		/**
		* 获得用户类型
		*/
		getUserType() {
			const params = {
				region: this.selectedRegion
			};
			Ajax.get('/api/usercenter/describeBaseInfo', params)
				.then((res) => {
					res.data = JSON.parse(res.data.meta);
					if (typeof res.data.edcps_vip !== 'undefined') {
						this.isVip = res.data.edcps_vip.toString() === '1';
						this.setTab('tab', 1, 1)
					} else {
                        // 这里如果不设置，非vip账号，带宽计费方式显示为空
                        this.initBandwidthPaymentTypes(1);
                    }
				})
				.catch(async (err) => {
					const { response } = err.data;
					try {
						const json = await response.json();
						this.$message.error(json.errmsg);
					} catch (ex) {
						console.log(ex);
					}
				});;
		},
		// 只能输入整数
		changeSelectedNumber(val) {
			clearTimeout(this.inputNumberTimeout);
			this.inputNumberTimeout = setTimeout(() => {
				let v = val.target.value;
				v = v.replace(/[^0-9]/ig, '');
				this.selectedHostNumber = v
			}, 200)
		},
		/**
		 * 跳转密钥列表
		 */
		jumpToKeys() {
			this.$router.push({
				path: '/ssh/list',
				query: {
					region: this.selectedRegion
				}
			});
		},
		/**
		 * 密钥对select为下拉状态时调用
		 * 获得最新密钥对信息
		 * @param tag
		 */
		getRealTimePublicKey(tag) {
			if (tag) {
				this.getPublicKey();
			}
		},
		/**
		 * 获得密钥对
		 * 当登陆方式为'密钥登陆'时调用
		 * 没有分页，所以pageSize为200
		 */
		getPublicKey() {
			const params = {
				region: this.selectedRegion,
				pageSize: 200
			};
			Ajax.get('/api/cps/listKeypairs', params)
				.then((res) => {
					this.ruleForm.publicKey = res.data.keypairs;
				})
				.catch(async (err) => {
					const { response } = err.data;
					try {
						const json = await response.json();
						this.$message.error(json.errmsg);
					} catch (ex) {
						console.log(ex);
					}
				});
		},
		/**
		 * 获得通过校验的输入内容
		 * 且内容已经base64过了
		*/
		getCustomData(value) {
			this.userData = value;
		},
		/**
		 * 区域切换时更新数据
		 * 切换时带宽值，购买数量初始化为1
		 * @param region
		 * */
		regionChange(region) {
			this.selectedStandard = '';
			this.clearPrice();
			this.selectedHostNumber = 1;
			this.netInfo.tmpMaxBandwidth = 1;
			this.netInfo.selectVpcId = '';
			this.netInfo.selectSubnetId = '';
      this.netInfo.vpcList = [];
      this.netInfo.subnetList = [];
      this.netInfo.isAuto = '0';
      this.netInfo.internetIp = '';
			this.netInfo.subnetCount = 0;

			this.extensionNetInfo.tmpMaxBandwidth = 1;
			this.extensionNetInfo.selectVpcId = '';
			this.extensionNetInfo.selectSubnetId = '';
      this.extensionNetInfo.vpcList = [];
      this.extensionNetInfo.subnetList = [];
      this.extensionNetInfo.isAuto = '0';
      this.extensionNetInfo.internetIp = '';
			this.extensionNetInfo.subnetCount = 0;
			this.ruleForm.selectKey = '';
			setTimeout(() => {
				this.$refs.networkInfo.resetFields();
				this.$refs.extensionNetInfo && this.$refs.extensionNetInfo.resetFields();
				this.$refs.ruleForm.clearValidate(['selectKey']);
			}, 2000);
			//this.selectedRegion = region;
		},
		zonesChange() {
            this.selectedStandard = '';
			this.clearPrice();
        },
		changeSeries() {
			this.clearPrice();
		},
		clearPrice() {
			this.discountedTotalPrice = '--';
			this.discountedServerPrice = '--';
			this.discountedMainEipPrice = '--';
            this.discountedExtensionEipPrice = '--';
			this.discountByConfigurationsServerPriceOneHour = '--';
            this.discountByConfigurationsMainEipPriceOneHour = '--';
			this.discountByConfigurationsExtensionEipPriceOneHour = '--';
			this.favorablePricePerHour = '--';
			this.totalPrice = '--';
			this.configurationTotalPrice = '--';
			this.configurationTotalDiscount = '--';
			this.totalDiscount = '--';
		},
		/*
		*  当前页面可以跳转其它页面创建vpc
		*  当创建完返回该页面时
		*  下拉操作后确保为最新的数据
		* */
		getRealTimeVpc(isVisible, tag) {
			if (isVisible) {
				this.getVpcCount(tag);
			}
		},
		/*
		*  当前页面可以跳转其它页面创建subnet
		*  当创建完返回该页面时
		*  下拉操作后确保为最新的数据
		* */
		getRealTimeSubnet(isVisible, tag) {
			if (!isVisible) {
				return
			}
			let vpcId = this[tag].selectVpcId
			this.getSubnetByVpc(vpcId, tag);
		},
		handleIconClick() {
			var keyWord = this.searchType.replace(/\s+|\t+/g, '');
			let target = [];
			if (this.selectedSeries === 'compute') {
				var typeInfo = this.deviceTypesTableData
			} else if (this.selectedSeries === 'storage') {
				var typeInfo = this.deviceTypesTableData1
			} else if (this.selectedSeries === 'gpu') {
				var typeInfo = this.deviceTypesTableData2
			};

			for (let i in typeInfo) {
				let allDeviceType = typeInfo[i].deviceType;
				if (allDeviceType.match(keyWord)) {
					target.splice(target.length, 0, typeInfo[i]);
				}
			}
			if (keyWord != '') {
				this.deviceTypesTable[this.selectedSeries] = target;
			} else if (this.selectedSeries === 'compute' && keyWord === '') {
				this.deviceTypesTable[this.selectedSeries] = this.deviceTypesTableData;
			} else if (this.selectedSeries === 'storage' && keyWord === '') {
				this.deviceTypesTable[this.selectedSeries] = this.deviceTypesTableData1;
			} else if (this.selectedSeries === 'gpu' && keyWord === '') {
				this.deviceTypesTable[this.selectedSeries] = this.deviceTypesTableData2;
			}
		},
		clearInputIp(tag) {
			this[tag].internetIp = '';
		},
		clearPrivateIpv6(val, tag) {
			this[tag].privateIpv6 = '';
		},
		jumpToVpcList() {
			const { href } = this.$router.resolve({
				name: 'PrivateNetworkList'
			});
			window.open(href, '_blank');
		},
		jumpToSubnetList() {
			const { href } = this.$router.resolve({
				name: 'SubnetList'
			});
			window.open(href, '_blank');
		},
		// 查询EIP配额
		getEipQuota() {
			const params = {
				region: this.selectedRegion
			};
			Ajax.get('/api/cps/eipQuota', params)
				.then((res) => {
					this.eipInfo.availableQuota = res.data.availableQuota;
					this.eipInfo.userQuota = res.data.userQuota;
				});
		},
		// 查询EIP库存
		getEipStock() {
			const params = {
				region: this.selectedRegion
			};
			Ajax.get('/api/bm/stock', params)
				.then((res) => {
					this.eipInfo.available = res.data.result.available;
				});
		},
		// 获取选取子网名称
		subnetChange(subnetId, tag) {
			this[tag].subnetList.forEach((subnet) => {
				if (subnet.subnetId === subnetId) {
					if (tag === 'netInfo') {
						this.selectedSubnetDetail = subnet;
					} else if (tag === 'extensionNetInfo') {
						this.selectedExtensionSubnetDetail = subnet;
					}
					this[tag].selectSubnetName = subnet.name;
					this[tag].selectSubnetCidr = subnet.cidr;
					this[tag].selectSubnetIpv6Cidr = subnet.ipv6Cidr;
					this.resetIpv4(tag)
					this.resetIpv6(subnet.ipv6Cidr, tag)
				}
			})
		},
		resetIpv4(tag) {
			this[tag].isAuto = 1;
			this[tag].internetIp = '';
		},
		resetIpv6(subnetIpv6Cidr, tag) {
			if (!subnetIpv6Cidr) {
				this[tag].privateIpv6Visible = false;
			} else {
				if (this[tag].privateIpv6Visible) {
					this[tag].isPrivateIpv6Auto = 1;
					this[tag].privateIpv6 = '';
				}
			}
		},
		// 获取选中vpc名称
		getSelectVpcName(vpcId, tag) {
			this[tag].vpcList.forEach((vpc) => {
				if (vpc.vpcId === vpcId) {
					this[tag].selectVpcName = vpc.name;
				}
			});
		},
		// 获取选中vpc cidr及ipv6 cidr
		getSelectVpcCidr(vpcId, tag) {
			this[tag].vpcList.forEach((vpc) => {
				if (vpc.vpcId === vpcId) {
					this[tag].selectVpcCidr = vpc.cidr;
					this[tag].selectVpcIpv6Cidr = vpc.ipv6Cidr;
				}
			});
		},
		// 获取当前vpc下子网
		getSubnetByVpc(id, tag) {
			const params = {
				region: this.selectedRegion,
				vpcId: id,
				pageSize: 100
			};
			Ajax.get('/api/cps/listSubnets', params)
				.then((res) => {
					this[tag].subnetList = res.data.subnets;
					this[tag].subnetCount = res.data.subnets.length;

					// this[tag].selectSubnetCidr = '';
					// this.resetIpv4(tag);
					// this[tag].privateIpv6Visible = false;
					// this[tag].isPrivateIpv6Auto = 1;
					// this[tag].privateIpv6 = '';
				})
				.catch(async (err) => {
					const { response } = err.data;
					try {
						const json = await response.json();
						this.$message.error(json.errmsg);
					} catch (ex) {
						console.log(ex);
					}
				})
		},
		// 获取选中当前vpc
		vpcChange(id, tag) {
			if (tag === 'netInfo') { // 主网卡
				this.selectedSubnetDetail = {};
				this.$refs.networkInfo.clearValidate(['selectSubnetId']);
			} else if (tag === 'extensionNetInfo') { // 符网口
				this.selectedExtensionSubnetDetail = {};
				this.$refs.extensionNetInfo.clearValidate(['selectSubnetId']);
			}
			this[tag].selectSubnetId = '';
			this[tag].selectSubnetName = '';
			this[tag].selectSubnetCidr = '';
			this[tag].selectSubnetIpv6Cidr = '';
			this.resetIpv4(tag);
			this[tag].privateIpv6Visible = false;
			this[tag].isPrivateIpv6Auto = 1;
			this[tag].privateIpv6 = ''
			if (id) {
				this.getSubnetByVpc(id, tag);
				this.getSelectVpcName(id, tag);
				this.getSelectVpcCidr(id, tag);
			}
		},
		// 获取当前区域下vpc
		getVpcCount(tag) {
			const params = {
				pageSize: 100,
				region: this.selectedRegion,
				pageSize: 100
			};
            // @ZTT 测试完成删除该行
            if (tag === 'netInfo') { // 主网口
                params.cidrToFilter = this.extensionNetInfo.selectVpcCidr;
                this.extensionNetInfo.vpcList  = [];
                this.privateNetInstanceExVpcLoading = true;
            } else if (tag === 'extensionNetInfo') { // 辅网口
                this.netInfo.vpcList = [];
                params.cidrToFilter = this.netInfo.selectVpcCidr;
                this.privateNetInstanceVpcLoading = true;
            }
			Ajax.get('/api/cps/listVpcs', params)
				.then((res) => {
					if (res.data.vpcs) {
						if (tag === 'netInfo') { // 主网口
							this.netInfo.vpcList = res.data.vpcs.filter(item => item.vpcId !== this.extensionNetInfo.selectVpcId);
							this.netInfo.vpcCount = this.netInfo.vpcList.length;
							if (this.netInfo.vpcList.length <= 0) {
								this.netInfo.vpcList = [{
									vpcId: '',
									showName: this.$t('privateNetInstance.notVPC'),
								}];
							}
						} else if (tag === 'extensionNetInfo') { // 辅网口
							this.extensionNetInfo.vpcList = res.data.vpcs.filter(item => item.vpcId !== this.netInfo.selectVpcId);
							this.extensionNetInfo.vpcCount = this.extensionNetInfo.vpcList.length;
							if (this.extensionNetInfo.vpcList.length <= 0) {
								this.extensionNetInfo.vpcList = [{
									vpcId: '',
									showName: this.$t('privateNetInstance.notVPC'),
								}];
							}
						} else {
							this.netInfo.vpcCount = this.extensionNetInfo.vpcCount = res.data.vpcs.length;
							this.netInfo.vpcList = this.extensionNetInfo.vpcList = res.data.vpcs;
							if (res.data.vpcs.length <= 0) {
								this.extensionNetInfo.vpcList = this.netInfo.vpcList = [{
									vpcId: '',
									showName: this.$t('privateNetInstance.notVPC'),
								}];
							}
						}
					}
				})
				.catch(async (err) => {
					const { response } = err.data;
					try {
						const json = await response.json();
						this.$message.error(json.errmsg);
					} catch (ex) {
						console.log(ex);
					}
				}).finally(() => {
                    this.privateNetInstanceExVpcLoading = false;
                    this.privateNetInstanceVpcLoading = false;
                });;
		},

		getClass(num) {
			if (VueCookie.get(this.GLOBALCOOKIE) == I18nConstant.CN || VueCookie.get(this.GLOBALCOOKIE) == null) {
				if (num === this.selectedMonth) {
					return 'cur';
				}
				if (this.selectedMonth > num) {
					return 'sel';
				}
				return '';
			}
			if (VueCookie.get(this.GLOBALCOOKIE) == I18nConstant.EN) {
				if (num === this.selectedMonth) {
					if (this.selectedMonth == 1) {
						return 'curSingleEn curEn';
					}
					return 'curEn';
				}
				if (this.selectedMonth > num) {
					return 'sel';
				}
				return '';
			}
		},

		getQuota() {
			const param = {
				serviceCode: ServiceCodeConstant.CPS
			};
			Ajax.get('/api/bm/getUserQuotas', param)
				.then((res) => {
					this.quotaNumber = res.data.userQuotas[this.selectedRegion];
				}).catch(async (err) => {
					const { response } = err.data;
					try {
						const json = await response.json();
						this.$message.error(json.errmsg);
					} catch (ex) {
						console.log(ex);
					}
				});

		},
		getRegion() {
			const param = {
				networkType: NetworkTypeConstant.VPC
			};
			Ajax.get('/api/cps/getRegions', param)
				.then((res) => {
					for (const i in res.data.regions) {
						const region = res.data.regions[i].region;
						const regionName = res.data.regions[i].regionName;
						const zones = res.data.regions[i].azs;
						this.regions[region] = regionName;
						for (const j in zones) {
							const az = zones[j].az;
							const azName = zones[j].azName;
							if (typeof this.zones[region] === 'undefined') {
								this.zones[region] = {};
							}
							this.zones[region][az] = azName;
						}
					}
					const passedRegion = this.$route.query.region;
					if (passedRegion != undefined) {
						this.selectedRegion = passedRegion;
						this.selectedZone = this.regions[passedRegion];
					} else {
						this.selectedRegion = res.data.regions[0].region;
						this.selectedZone = res.data.regions[0].azs[0].az;
					}
					// this.getVpcCount();
					// this.getDiscountInfo();
					// this.getUserType();
					// this.getEipQuota();
					// this.getEipStock();
					// this.getLineTypes();
				}).catch(async (err) => {
					const { response } = err.data;
					try {
						const json = await response.json();
						this.$message.error(json.errmsg);
					} catch (ex) {
						console.log(ex);
					}
				});
		},
		getLineTypes() {
			const param = {
				region: this.selectedRegion
			};
			Ajax.get('/api/cps/getLineTypes', param)
				.then((res) => {
					const data = res.data.lineTypes;
					for (let i = 0; i < data.length; i++) {
						this.lineTypes[data[i].lineType] = data[i].lineTypeName;
					}
					this.netInfo.selectedLineType = this.extensionNetInfo.selectedLineType = Object.keys(this.lineTypes)[0];
				}).catch(async (err) => {
					const { response } = err.data;
					try {
						const json = await response.json();
						this.$message.error(json.errmsg);
					} catch (ex) {
						console.log(ex);
					}
				});
		},
		isSkuSoldOut(isSoldOut) {
			return isSoldOut === true || isSoldOut === 'true' || isSoldOut === 1 || isSoldOut === '1';
		},
		initSelectedStandardBySeries(series) {
			const deviceTypesTableList = (this.deviceTypesTable && this.deviceTypesTable[series]) || [];
			// 历史逻辑：仅当列表首项未售罄时默认选中首项
			// if (deviceTypesTableList && !deviceTypesTableList[0]?.isSoldOut) {
			// 	this.selectedStandard = deviceTypesTableList[0]?.deviceType;
			// }
			// 新逻辑：默认选中当前系列第一个未售罄sku
			const availableSku = deviceTypesTableList.find(item => item && !this.isSkuSoldOut(item.isSoldOut));
			if (availableSku) {
				this.selectedStandard = availableSku.deviceType;
				// 回显赋值规格类型，用于 isGameServe 的类型校验
				this.spcTypeName = availableSku.name;
			} else {
				this.selectedStandard = '';
				this.spcTypeName = '';
			}
			this.showOsTypes = !!this.selectedStandard;
		},
		getDeviceType() {
			this.deviceTypesArr = [];
			this.deviceTypesNum = [];
			Ajax.get({
				action: '/getAvailableDeviceTypes',
				param: { region: this.selectedRegion, az: this.selectedZone },
				success: (data) => {

					const deviceTypes = {};
					const deviceTypesNum = {};
					this.deviceTypesTable = data.deviceTypes;
					const seriesKeys = Object.keys(this.deviceTypesTable);
					let defaultSeries = seriesKeys[0] || '';
					this.deviceTypesTableData = deepCopy(this.deviceTypesTable[seriesKeys[0]]);
					this.deviceTypesTableData1 = deepCopy(this.deviceTypesTable[seriesKeys[1]]);
					this.deviceTypesTableData2 = deepCopy(this.deviceTypesTable[seriesKeys[2]]);

					// 历史逻辑：按 gpu -> storage -> compute 多次覆盖 selectedSeries
					// if (this.deviceTypesTableData2) {
					// 	this.deviceTypesTableData2.map((item) => {
					// 		if (!item.isSoldOut) {
					// 			this.selectedSeries = 'gpu'
					// 		}
					// 	})
					// }
					// if (this.deviceTypesTableData1) {
					// 	this.deviceTypesTableData1.map((item) => {
					// 		if (!item.isSoldOut) {
					// 			this.selectedSeries = 'storage'
					// 		}
					// 	})
					// }
					// if (this.deviceTypesTableData) {
					// 	this.deviceTypesTableData.map((item) => {
					// 		if (!item.isSoldOut) {
					// 			this.selectedSeries = 'compute'
					// 		}
					// 	})
					// }

					// 新逻辑：仅计算一次默认系列（优先 compute -> storage -> gpu 的未售罄系列）
					const seriesPriority = ['compute', 'storage', 'gpu'];
					for (let i = 0; i < seriesPriority.length; i++) {
						const series = seriesPriority[i];
						const seriesList = this.deviceTypesTable[series] || [];
						if (seriesList.some(item => item && !this.isSkuSoldOut(item.isSoldOut))) {
							defaultSeries = series;
							break;
						}
					}
					for (var i in data.deviceTypes) {
						for (const item in data.deviceTypes[i]) {
							const nameEN = data.deviceTypes[i][item].deviceType;
							deviceTypes[nameEN] = data.deviceTypes[i][item];
							this.deviceTypesArr.push(data.deviceTypes[i][item]);
							this.deviceTypesNum[nameEN] = 1;
						}
					}
					for (let z = 0; z < this.deviceTypesArr.length; z++) {
						this.checkStockEnough(this.selectedRegion, this.selectedZone,
							this.deviceTypesArr[z].deviceType, this.selectedHostNumber, true);
					}
					this.deviceTypes = deviceTypes;
					this.deviceTypesNum = deviceTypesNum;
					// 历史逻辑（初始化阶段在getDeviceType中多分支赋值selectedStandard）已注释
					// selectedStandard 初始化统一由 selectedSeries 监听处理：
					// 默认选择“当前系列第一个未售罄sku”，避免重复赋值覆盖
					// if (this.allSold) {
					// 	this.selectedStandard = '';
					// } else if (this.deviceTypesArr.length > 1) {
					// 	for (var i = 0; i < this.deviceTypesArr.length; i++) {
					// 		if (this.deviceTypesNum[this.deviceTypesArr[i].deviceType]) {
					// 			this.selectedStandard = this.deviceTypesArr[i].deviceType;
					// 			break;
					// 		}
					// 	}
					// } else if (this.deviceTypesArr.length = 1) {
					// 	this.selectedStandard = this.deviceTypesArr[0].deviceType;
					// }
					const oldSelectedSeries = this.selectedSeries;
					this.selectedSeries = defaultSeries;
					// 当系列值未变化时，watch(selectedSeries)不会触发，需在初始化链路兜底赋值
					if (oldSelectedSeries === defaultSeries) {
						this.initSelectedStandardBySeries(defaultSeries);
					}
				}
			});
		},
		getAvailableOS(selectedImage) {
            // 当实例规格类型为空时（所选系列规格类型售罄）selectedStandard为空，获取操作系统接口强依赖selectedStandard，此处做个拦截
            if (!this.selectedStandard) {
                return
            }
			const param = { region: this.selectedRegion, deviceType: this.selectedStandard };
			Ajax.get({
				action: '/getAvailableOS',
				param,
				success: (data) => {
					const osTypes = {};
					this.customOsTypes = {};
					// 用来验证版本是不是最新的版本，将最新的版本放在最上面
					let osVersionOne = 10000;
					let osVersionTwo = 10000;
					const imageTypes = data.oss.map(item => {
						return {
							source: item.source,
							sourceName: item.sourceName,
						}
					});
					var obj = {};
					this.imageTypes = imageTypes.reduce(function (item, next) {
						obj[next.source] ? '' : obj[next.source] = true && item.push(next);
						return item;
					}, []);
                    // 按照order顺序对this.imageTypes进行排序，防止每次“镜像类型”位置变动
                    const order = ['common', 'customize', 'user_defined_create']
                    this.imageTypes = this.imageTypes?.sort((a, b) => {
                        return order.indexOf(a?.source) - order.indexOf(b?.source);
                    });
					const dataList = data.oss.filter(item => item.source === this.imageTypes[selectedImage].source);
					for (const i in dataList) {
						const osTypeId = dataList[i].osTypeId;
						const osType = dataList[i].osType;
						const osName = dataList[i].osName;
						const osFormat = dataList[i].format;

						if (!osTypes[osType]) {
							osTypes[osType] = [];
						}
						if (dataList[i].osVersion < osVersionOne) {
							osTypes[osType].push({ osTypeId, osName, osFormat });
						} else {
							osTypes[osType].splice(0, 0, { osTypeId, osName, osFormat });
							osVersionOne = dataList[i].osVersion;
						}

						if (osType !== 'Ubuntu') {
							if (this.customOsTypes[osType] === undefined) {
								this.customOsTypes[osType] = [];
							}
							if (dataList[i].osVersion < osVersionTwo) {
								this.customOsTypes[osType].push({ osTypeId, osName, osFormat });
							} else {
								this.customOsTypes[osType].splice(0, 0, { osTypeId, osName, osFormat });
								osVersionTwo = dataList[i].osVersion;
							}
						}
					}
					this.osTypes = osTypes;
					this.standardOsTypes = $.extend(true, {}, this.osTypes);
					if (osTypes.CentOS) {
						this.selectedOS = 'CentOS';
					} else {
						// this.selectedOS = dataList[0].osType;
                        // 切换radio 筛选当前选中的镜像类型，用于默认选中第一个的操作系统 selectedImageType: 0-公共镜像，1-定制镜像，默认0
                        const selectedImageTypeData = this.imageTypes[this.selectedImageType];
                        const selectedOSData = data?.oss?.length && data.oss.find(item => {
                            return selectedImageTypeData.source === item.source;
                        });
                        // 增加容错
                        this.selectedOS = selectedOSData ? selectedOSData?.osType : dataList[0]['osType'];
					}
					if (this.imageTypes[this.selectedImageType].source !== 'standard_app') {
						this.osTypes = $.extend(true, {}, this.standardOsTypes);
					} else {
						this.selectedOS = 'CentOS';
						this.osTypes = $.extend(true, {}, this.customOsTypes);
					}
                    // 轮询 this.osTypes ，用于判断操作系统是否选择 --
                    // this.showOsTypes = false;
                    // for (const key in this.osTypes) {
                    //     if (this.osTypes[key] && this.osTypes[key]?.length) {
                    //         this.showOsTypes = true;
                    //     }
                    // }
				}
			});
		},

		getAvailableRaids(selectedStandard) {
			if (!selectedStandard) return;
			Ajax.get({
				action: '/getAvailableRaids',
				param: {
					deviceType: selectedStandard,
					region: this.selectedRegion
				},
				success: (data) => {
					const raids = [];
					for (const i in data.raids) {
						// 系统盘raids
						if (data.raids[i].volumeType == 'system') {
							const volume1 = data.raids[i].volumeDetail.split('(').join(' (');
							let sysDiskCapacity = data.raids[i].availableValue;
							// 京造服务器包含两块系统盘，分区时候只能用一个
							let systemPartitionCount = data.raids[i].systemPartitionCount;
							sysDiskCapacity = sysDiskCapacity / systemPartitionCount;
							this.calculateDiskCapacity('system', sysDiskCapacity);
							const volume = volume1.split(')');
							const raidType = ` ${this.radisNameMap[data.raids[i].raidType]})`;
							// var newRaidName = volume.replace(')', raidType);
							const newRaidName = volume + raidType;
							this.selectedSysRaidName = newRaidName;
							// this.selectedSysRaidName = data['raids'][i]['volumeDetailed']+","+data['raids'][i]['raidType']
							this.selectedSysRaidTip = data.raids[i].description;
							this.selectedOSRaidId = data.raids[i].raidTypeId;
						} else { // 数据盘raids
							if (data.raids[i].raidType === 'NO RAID') {
								raids.splice(0, 0, data.raids[i]);
							} else {
								raids.push(data.raids[i]);
							}
						}
					}
					this.raids = raids;
					//优化根据不同的机型设置默认选中的不同raid卡逻辑
					if (raids.length > 0) {
						this.selectedDataRaid = raids[raids.length - 1];
						this.resetDataPartitionModes(this.selectedDataRaid);
						this.selectedDataRaidId = this.selectedDataRaid['raidTypeId']
						let dataVolume1 = this.selectedDataRaid['volumeDetail']
						let dataVolume2 = dataVolume1.split('TB').join('TB ')
						let dataVolume = dataVolume2.split('GB').join('GB ')
						if (this.selectedDataRaid.deviceType === 'cps.s.perf1') {
							let dataRaidType = ', ' + this.customRaidsNameMap[this.selectedDataRaid['raidType']] +
								')'
							let tempDataRaidName = dataVolume.replace(')', dataRaidType);
							let lastIndex = tempDataRaidName.lastIndexOf(')')
							let beginString = tempDataRaidName.substring(0, lastIndex)
							var dataRaidName = beginString + ', ' + this.customRaidsNameMap['NORAID'] + ')'
						} else if (this.selectedDataRaid.deviceType === 'cps.c.perf3') {
							var dataRaidType = ', ' + this.customRaidsNameMap[this.selectedDataRaid['raidType']] + ')'
							var dataRaidName = dataVolume.replace(')', dataRaidType);
						} else {
							var dataRaidType = ', ' + this.radisNameMap[this.selectedDataRaid['raidType']] + ')'
							var dataRaidName = dataVolume.replace(')', dataRaidType);
						}
						let dataDiskCapacity = this.selectedDataRaid.availableValue;
						this.calculateDiskCapacity('data', dataDiskCapacity);
						this.selectedDataRaidName = dataRaidName;
					} else {
						this.selectedDataRaidId = '';
						this.selectedDataRaidName = '--'
					}
				}
			});
		},

		// noraid数据盘分区模式特殊处理
		resetDataPartitionModes(item) {
			// 机型不支持自定义分区就不需要再对数据盘单独处理
			if (!this.deviceCustomPartitionSupport) {
				return
			}
			if (item.raidType === 'NORAID') {
				this.dataDiskPartitionModes = [
					{ id: 1, label: this.$t('create.text.defaultPartitionModes'), value: 'default' },
				];
			} else {
				this.dataDiskPartitionModes = [
					{ id: 1, label: this.$t('create.text.defaultPartitionModes'), value: 'default' },
					{ id: 2, label: this.$t('create.text.customPartitionModes'), value: 'custom' },
				];
			}
			this.selectedDataDiskPartitionMode = 'default';
		},

		// 是否支持自定义分区
		resetPartitionModes(customPartitionSupport) {
			if (!customPartitionSupport) {
				this.systemDiskPartitionModes = [
					{ id: 1, label: this.$t('create.text.defaultPartitionModes'), value: 'default' }
				];
				this.dataDiskPartitionModes = [
					{ id: 1, label: this.$t('create.text.defaultPartitionModes'), value: 'default' }
				];
			} else {
				this.systemDiskPartitionModes = [
					{ id: 1, label: this.$t('create.text.defaultPartitionModes'), value: 'default' },
					{ id: 2, label: this.$t('create.text.customPartitionModes'), value: 'custom' },
				],
					this.dataDiskPartitionModes = [
						{ id: 1, label: this.$t('create.text.defaultPartitionModes'), value: 'default' },
						{ id: 2, label: this.$t('create.text.customPartitionModes'), value: 'custom' },
					];
			}
			this.selectedPartitionMode = 'default';
			this.selectedDataDiskPartitionMode = 'default';
		},

		getOSPartitions() {
			if (!this.selectedRegion || !this.selectedStandard || !this.selectedOSTypeId) {
				return
			}
			const param = {
				region: this.selectedRegion,
				deviceType: this.selectedStandard,
				imageId: this.selectedOSTypeId
			};
			Ajax.get('/api/cps/getOSPartitions', param)
				.then((res) => {
					let partitions = res.data.partitions;
					this.handleSystemPartitions(partitions);
					this.handleDataPartitions(partitions);
				}).catch(async (err) => {
					const { response } = err.data;
					try {
						const json = await response.json();
						this.$message.error(json.errmsg);
					} catch (ex) {
						console.log(ex);
					}
				});
		},

		dealRemainSystemDataPartitions(diskSize, diskPartitions) {
			return diskSize - diskPartitions.filter(item => item.size !== 999999999).reduce((init, current) => {
				return init + current.size
			}, 0);
		},

		dealDefaultPartitions(partitions) {
			let defaultPartitions = deepCopy(partitions);
			defaultPartitions.map((item) => {
				item.size = item.isRemainDataPartition ? this.$t('retailInstance.text.allRemainingSpace') : `${item.size}GiB`;
			});

			return defaultPartitions.reduce((init, current) => {
				return `${init}<strong class="ml5 mr5">${current.point}:</strong><span>${current.size},${current.format};</span>`
			}, '')
		},

		handlePartitions(remainPartitions, diskPartitions, type) {
			let hasRemainDataPartition = false;
			let systemDataPartitions = diskPartitions.map(item => {
				item.isEditing = false;
				if (item.size === 999999999) {
					item.size = remainPartitions;
					item.isRemainDataPartition = true;
					hasRemainDataPartition = true;
				}
				item.size = item.size / 1024;
				return item
			});

			if (type === 'systemDisk') {
				this.defaultSystemDataPartitions = this.dealDefaultPartitions(systemDataPartitions);
			} else if (type === 'dataDisk') {
				this.defaultDataDiskPartitions = this.dealDefaultPartitions(systemDataPartitions);
			}
			systemDataPartitions.push({
				point: this.$t('retailInstance.text.emptyPartition'),
				isEditing: false,
				size: hasRemainDataPartition ? 0 : parseInt(remainPartitions / 1024, 10),
				format: this.isCentOS66 ? 'ext3' : 'xfs',
				isNoPartition: true
			});
			systemDataPartitions.map(item => {
				if (item.point === '/') {
					item.minSize = 5;
				} else if (item.point === '/boot') {
					item.minSize = 1;
				} else {
					item.minSize = 0;
				}
				item.maxSize = item.size + (hasRemainDataPartition ? 0 : parseInt(remainPartitions / 1024, 10))
				return item
			});
			return systemDataPartitions
		},

		handleSystemPartitions(partitions) {
			let remainSystemDataPartitions = this.dealRemainSystemDataPartitions(this.systemDiskSize * 1024, partitions.systemDiskPartitions);
			this.systemDataPartitions = this.handlePartitions(remainSystemDataPartitions, partitions.systemDiskPartitions, 'systemDisk');
		},

		handleDataPartitions(partitions) {
			let remainSystemDataPartitions = this.dealRemainSystemDataPartitions(this.dataDiskSize * 1024, partitions.dataDiskPartitions);
			this.dataDiskPartitions = this.handlePartitions(remainSystemDataPartitions, partitions.dataDiskPartitions, 'dataDisk');
		},
		resetDiskCapacity(type) {
			if (!this.selectedOSTypeId || !this.selectedRegion || !this.selectedStandard) {
				return
			}
			const param = {
				region: this.selectedRegion,
				deviceType: this.selectedStandard,
				imageId: this.selectedOSTypeId
			};
			Ajax.get('/api/cps/getOSPartitions', param)
				.then((res) => {
					let partitions = res.data.partitions;
					if (type === 'system') {
						this.handleSystemPartitions(partitions);
					} else if (type === 'data') {
						this.handleDataPartitions(partitions);
					}
				}).catch(async (err) => {
					const { response } = err.data;
					try {
						const json = await response.json();
						this.$message.error(json.errmsg);
					} catch (ex) {
						console.log(ex);
					}
				});
		},

		calculateDiskCapacity(type, capacity) {
			let diskCapacity = Math.floor(capacity * 0.93);
			if (type === 'system') {
				this.sysDiskCapacity = diskCapacity + 'GiB';
				this.systemDiskSize = diskCapacity;
			} else if (type === 'data') {
				this.dataDiskCapacity = diskCapacity + 'GiB';
				this.dataDiskSize = diskCapacity;
			}
		},

		checkStockEnough(region, az, selectedStandard, selectedHostNumber, init) {
			// init 用来区分是不是初始化,不是初始化,则不用传值,是初始化则传true
			if (!region || !az || !selectedStandard) {
				return;
			}
			const param = {
				region,
				az,
				deviceType: selectedStandard,
				count: selectedHostNumber
			};
			Ajax.get({
				url: '/api/bm',
				action: '/isStockEnough',
				param,
				success: (data) => {
                    // data = true // 手动mock数据
					this.deviceTypesNum[selectedStandard] = data;
					const newDeviceTypesNum = $.extend(true, {}, this.deviceTypesNum);
					this.deviceTypesNum = $.extend(true, {}, newDeviceTypesNum);
					if (init) {
						this.cacheDeviceTypesNum[selectedStandard] = data;
						const cacheDeviceTypesNum = $.extend(true, {}, this.cacheDeviceTypesNum);
						this.cacheDeviceTypesNum = $.extend(true, {}, cacheDeviceTypesNum);
						this.cacheDeviceTypesNum[''] = false;
						for (let z = 0; z < this.deviceTypesArr.length; z++) {
							const name = this.deviceTypesArr[z].deviceType;
							this.allSold = this.allSold && (this.deviceTypesNum[name] != undefined || this.deviceTypesNum[name] != false);
						}
						// 历史逻辑（初始化库存回调中循环赋值selectedStandard）已注释，避免重复赋值覆盖当前系列默认值
						// for (let z = 0; z < this.deviceTypesArr.length; z++) {
						// 	const name = this.deviceTypesArr[z].deviceType;
						// 	this.allSold = this.allSold && (this.deviceTypesNum[name] != undefined || this.deviceTypesNum[name] != false);
						// 	if (this.deviceTypesNum[name]) {
						// 		this.selectedStandard = name;
						// 		// 回显赋值 规格类型，用于 isGameServe 的类型校验
						// 		this.spcTypeName = this.deviceTypesArr[z].name;
						// 		break;
						// 	}
						// }

					}

					if (this.deviceTypesNum[this.selectedStandard] !== undefined) {
						this.isStockEnough = this.deviceTypesNum[this.selectedStandard];
					}
				}
			});
		},
		calculateTotalPrice() {
			if (!this.selectedRegion || !this.selectedStandard) {
				return '';
			}
			this.isCalculatIng = true;
			this.discountedTotalPrice = this.$t('create.text.calculating');
			this.discountedServerPrice = this.$t('create.text.calculating');
			this.discountedMainEipPrice = this.$t('create.text.calculating');
            this.discountedExtensionEipPrice = this.$t('create.text.calculating');
			// this.totalPrice = this.$t('create.text.calculating');
			// this.totalDiscount = this.$t('create.text.calculating');
			const param = {
				cmd: 1, // 创建
				region: this.selectedRegion,
				timeUnit: this.timeUnit, // 月
				timeSpan: this.timeUnit == 3 ? this.selectedMonth : this.selectedYear,
				// 主网口
				internetChargeMode: BillingTypesConstant.PREPAID_BY_DURATION,
				bw: (this.netInfo.radioIp && this.netInfo.selectedPaymentType !== 3) ? this.netInfo.selectedMaxBandwidth : 0, // 带宽
				// 辅网口
				extensionInternetChargeMode: BillingTypesConstant.PREPAID_BY_DURATION,
				extensionBw: (this.extensionNetInfo.radioIp && this.extensionNetInfo.selectedPaymentType !== 3) ? this.extensionNetInfo.selectedMaxBandwidth : 0,
				count: this.selectedHostNumber,
				deviceType: this.selectedStandard,
				createType: CreateTypeConstant.VPC,
				billingType: BillingTypesConstant.PREPAID_BY_DURATION
			};
			// 共享带宽兼容处理
			if (!this.netInfo.radioIp) {
				delete param.bw
			}
			if (!this.extensionNetInfo.radioIp) {
				delete param.extensionBw
			}
			// 如果非整数，不计算价格
			if (!/^\d+$/.test(this.selectedHostNumber)) {
				return false;
			}
			Ajax.get('/api/price/calculateTotalPrice', param).then(res => {
        const { discountedTotalPrice, totalPrice, totalDiscount, list } = res?.data || {};
				this.discountedTotalPrice = changeTwoDecimal(discountedTotalPrice);
				this.discountedServerPrice = changeTwoDecimal(list.length && list[0] && list[0]?.discountedPrice);
				if (this.netInfo.radioIp && this.extensionNetInfo.radioIp) {
					this.discountedMainEipPrice = changeTwoDecimal(list.length && list[1] && list[1]?.discountedPrice);
					this.discountedExtensionEipPrice = changeTwoDecimal(list.length && list[2] && list[2]?.discountedPrice);
				}
				if (this.netInfo.radioIp && !this.extensionNetInfo.radioIp) {
					this.discountedMainEipPrice = changeTwoDecimal(list.length && list[1] && list[1]?.discountedPrice);
				}
				if (!this.netInfo.radioIp && this.extensionNetInfo.radioIp) {
					this.discountedExtensionEipPrice = changeTwoDecimal(list.length && list[1] && list[1]?.discountedPrice);
				}
				this.totalPrice = changeTwoDecimal(totalPrice);
				this.totalDiscount = changeTwoDecimal(totalDiscount);
        this.favorablePricePerHour = totalDiscount ? changeTwoDecimal(subDecimals(totalPrice, discountedTotalPrice)) : '--';
			}).catch(() => {
				this.clearPrice();
			}).finally(() => {
				this.isCalculatIng = false;
			});
			return '';
		},
		configurationsCalculateTotalPrice() {
			if (!this.selectedRegion || !this.selectedStandard) {
				return '';
			}
			this.isConfigurationsCalculatIng = true;
			this.discountByConfigurationsServerPriceOneHour = this.$t('create.text.calculating');
            this.discountByConfigurationsMainEipPriceOneHour = this.$t('create.text.calculating');
			this.discountByConfigurationsExtensionEipPriceOneHour = this.$t('create.text.calculating');
			const param = {
				cmd: 1, // 创建
				region: this.selectedRegion,
				internetChargeMode: BillingTypesConstant.POSTPAID_BY_DURATION,
				bw: (this.netInfo.radioIp && this.netInfo.selectedPaymentType !== 3) ? this.netInfo.selectedMaxBandwidth : 0,
				extensionInternetChargeMode: BillingTypesConstant.POSTPAID_BY_DURATION,
				extensionBw: (this.extensionNetInfo.radioIp && this.extensionNetInfo.selectedPaymentType !== 3) ? this.extensionNetInfo.selectedMaxBandwidth : 0,
				count: this.selectedHostNumber,
				deviceType: this.selectedStandard,
				createType: CreateTypeConstant.VPC,
				billingType: BillingTypesConstant.POSTPAID_BY_DURATION
			};
			// 共享带宽兼容处理
			if (!this.netInfo.radioIp) {
				delete param.bw
			}
			if (!this.extensionNetInfo.radioIp) {
				delete param.extensionBw
			}
			// 如果非整数，不计算价格
			if (!/^\d+$/.test(this.selectedHostNumber)) {
				return false;
			}
			Ajax.get('/api/price/calculateTotalPrice', param).then(res => {
        const { discountedTotalPrice, list, totalPrice, totalDiscount } = res?.data || {};
				this.discountByConfigurationsTotalPrice = changeTwoDecimal(discountedTotalPrice);
				this.discountByConfigurationsOneMonthPrice = changeTwoDecimal(mulDecimals(mulDecimals(discountedTotalPrice, 24), 30));
				this.discountByConfigurationsServerPriceOneHour = changeTwoDecimal(list.length ? list[0]?.discountedPrice : '');
				if (this.netInfo.radioIp && this.extensionNetInfo.radioIp) {
					this.discountByConfigurationsMainEipPriceOneHour = changeTwoDecimal(list.length && list[1] && list[1]?.discountedPrice);
					this.discountByConfigurationsExtensionEipPriceOneHour = changeTwoDecimal(list.length && list[2] && list[2]?.discountedPrice);
				}
				if (this.netInfo.radioIp && !this.extensionNetInfo.radioIp) {
					this.discountByConfigurationsMainEipPriceOneHour = changeTwoDecimal(list.length && list[1] && list[1]?.discountedPrice);
				}
				if (!this.netInfo.radioIp && this.extensionNetInfo.radioIp) {
					this.discountByConfigurationsExtensionEipPriceOneHour = changeTwoDecimal(list.length && list[1] && list[1]?.discountedPrice);
				}
				this.configurationTotalPrice = changeTwoDecimal(totalPrice);
				this.configurationTotalDiscount = totalDiscount ? changeTwoDecimal(subDecimals(totalPrice, discountedTotalPrice)) : '--';
			}).catch(() => {
				this.clearPrice();
			}).finally(() => {
				this.isConfigurationsCalculatIng = false;
			});
			return '';
		},
		calSelectedMaxBandwidth(val, tag) {
			this[tag].selectedMaxBandwidth = this[tag].tmpMaxBandwidth;
		},
		selectStandard(standard, row) {
			this.spcTypeName = row.name;
			if (!this.deviceTypesNum[standard]) {
				return;
			}
			this.selectedStandard = standard;
			this.selectedApplication = [];
		},
		selectApplication(name) {
			for (var i in this.selectedApplication) {
				if (name == this.selectedApplication[i].name) {
					this.selectedApplication.splice(i, 1);
					return;
				}
			}
			const arr = [];
			for (var i in this.applications) {
				if (name == this.applications[i].name) {
					this.selectedApplication.push({ name, version: this.applications[i].version });
					return;
				}
			}
		},
		selectDataRaid(item) {
			this.resetDataPartitionModes(item)
			this.selectedDataRaid = item;
			this.selectedDataRaidId = item.raidTypeId;
			const dataVolume1 = item.volumeDetail.split(' ').join('');
			const dataVolume2 = dataVolume1.split('TB').join('TB ');
			const dataVolume = dataVolume2.split('GB').join('GB ');
			const dataRaidType = `, ${this.radisNameMap[item.raidType]})`;
			const dataRaidName = dataVolume.replace(')', dataRaidType);
			let dataDiskCapacity = item.availableValue;
			this.calculateDiskCapacity('data', dataDiskCapacity);
			// 重置数据盘
			this.resetDiskCapacity('data');
			this.selectedDataRaidName = dataRaidName;
		},
		selectMonth(selMonth) {
			this.chargeUnit = 3;
			this.timeUnit = 3;
			this.selectedMonth = selMonth;
			this.otherMonth = selMonth;
			switch (selMonth) {
				case 12:
					this.cutMonth = 2;
					break;
				case 24:
					this.cutMonth = 4;
					break;
				case 36:
					this.cutMonth = 6;
					break;
				default:
					this.cutMonth = 0;
			}
		},
		selectYear(selYear) {
			switch (selYear) {
				case 1:
					this.selectedMonth = 12;
					break;
				case 2:
					this.selectedMonth = 24;
					break;
				case 3:
					this.selectedMonth = 36;
					break;
				default:
					this.cutMonth = 0;
			}
			this.selectedYear = selYear;
			this.chargeUnit = 4;
			this.timeUnit = 4;
		},
		jump_to_up() {
			this.$router.push({
				path: '/instance/vpc/list',
				query: {
					region: this.selectedRegion
				}
			});
		},
		/**
		 **@disc:定位到页面上未通过校验元素
		 **@params: element id
		 */
		locateToErrorElement(id) {
			$('.mainCon').scrollTop($('.mainCon').scrollTop() + $(`#${id}`).offset().top
				- $('.mainCon').offset().top - 100);
		},
		buy() {
			let formValid = true;
			this.$refs.ruleFormType.validate((valid) => {
				formValid = valid;
			});
			if (!formValid) {
				if (this.$refs.application !== undefined) {
					this.ruleFormTag.application = this.$refs.application.validateState;
				}
				this.locateToErrorElement('imgType');
				return false;
			}
			// 校验系统盘及数据盘自定义分区模式下是否保存
			if (this.$refs.systemPartition && this.$refs.systemPartition.isRowNotSaved) {
				this.locateToErrorElement('storage');
				return false;
			}
			if (this.$refs.dataPartition && this.$refs.dataPartition.isRowNotSaved) {
				this.locateToErrorElement('storage');
				return false;
			}
			this.$refs.networkInfo.validate((valid) => {
				formValid = valid;
			});

			if (!formValid) {
				this.locateToErrorElement('network');
				return false;
			}
			// 双网口模式下校验辅网口相关信息必填项
			let networkQuantity = this.selectedNetworkQuantity;
			if (networkQuantity === 'dual') {
				this.$refs.extensionNetInfo.validate((valid) => {
					formValid = valid;
				});
				if (!formValid) {
					this.locateToErrorElement('extensionNet');
					return false;
				}
			}
			this.$refs.advancedCustomData.$refs.advanced.validate((valid) => {
				formValid = valid;
			});
			if (!formValid) {
				this.locateToErrorElement('advanced');
				return false;
			}
			this.$refs.tagForm.validate((valid) => {
				formValid = valid;
			});
			if (!formValid) {
				this.locateToErrorElement('advanced');
				return false;
			}
			this.$refs.ruleForm.validate((valid) => {
				formValid = valid;
			});

			if (!formValid && this.passwordType === "custom") {
				this.ruleFormTag.hostName = this.$refs.hostName.validateState;
				this.ruleFormTag.hostDesc = this.$refs.hostDesc.validateState;
				this.ruleFormTag.hostPwd = this.$refs.hostPwd.validateState;
				this.ruleFormTag.hostConfirmPwd = this.$refs.hostConfirmPwd.validateState;
				this.ruleFormTag.mainName = this.$refs.mainName.validateState;
				this.locateToErrorElement('baseInfo');
				return false;
			}
			if (!formValid && this.passwordType === "key") {
				this.ruleFormTag.hostName = this.$refs.hostName.validateState;
				this.ruleFormTag.hostDesc = this.$refs.hostDesc.validateState;
				this.ruleFormTag.mainName = this.$refs.mainName.validateState;
				this.locateToErrorElement('baseInfo');
				return false;
			}

			if (!formValid && this.passwordType === "auto") {
				this.ruleFormTag.hostName = this.$refs.hostName.validateState;
				this.ruleFormTag.hostDesc = this.$refs.hostDesc.validateState;
				this.ruleFormTag.mainName = this.$refs.mainName.validateState;
				this.locateToErrorElement('baseInfo');
				return false;
			}

			const param = {
				region: this.selectedRegion,
				az: this.selectedZone,
				deviceType: this.selectedStandard,
				count: this.selectedHostNumber
			};
			Ajax.get({
				url: '/api/bm',
				action: '/isStockEnough',
				param,
				success: (data) => {
					if (data == true) {
						this.isStockEnough = true;
						this.createOrder();
					} else {
						this.isStockEnough = false;
					}
				}
			});
		},
		createOrder() {
			const selectedDeviceData = this.deviceTypes[this.selectedStandard];
			const selectedDeviceName = selectedDeviceData.deviceType;
			let systemDiskPartitions = this.systemDataPartitions.filter(item => !item.isNoPartition).map(item => {
				return {
					"size": item.size,
					"format": item.format,
					"point": item.point
				}
			});
			if (this.selectedPartitionMode === 'default') {
				systemDiskPartitions = [];
			}
			let dataDiskPartitions = this.dataDiskPartitions.filter(item => !item.isNoPartition).map(item => {
				return {
					"size": item.size,
					"format": item.format,
					"point": item.point
				}
			});
			if (this.selectedDataDiskPartitionMode === 'default') {
				dataDiskPartitions = [];
			}
			const param = {
				orderType: 1, // 新购
				chargeMode: this.currentMode === 'tab1' ? 3 : 1, // 计费类型 包年包月
				region: this.selectedRegion, //地域
				az: this.selectedZone, // 可用区
				deviceType: this.selectedStandard, // 规格
				imageType: 'standard', // 镜像类型
				imageName: this.selectedOSName, // 镜像名称
				deviceName: selectedDeviceName,
				osTypeId: this.selectedOSTypeId, // 镜像ID
				sysRaidTypeId: this.selectedOSRaidId, // 系统盘raid
				dataRaidTypeId: this.selectedDataRaidId, // 数据盘raid
				sysRaidName: this.selectedSysRaidName,
				dataRaidName: this.selectedDataRaidName,
				interfaceMode: this.selectedNetworkQuantity, //网络接口数量
				vpc: this.netInfo.selectVpcName, // 主网口私有网络
				subnet: this.netInfo.selectSubnetName, // 主网口子网名称
				subnetId: this.netInfo.selectSubnetId, // 主网口子网ID
				cidr: this.netInfo.selectSubnetCidr, // 主网口子网cidr
				lineType: this.netInfo.selectedLineType, // 主网口线路类型
				bw: this.netInfo.radioIp ? this.netInfo.selectedMaxBandwidth : 0, // 主网口带宽
				internetChargeMode: this.netInfo.selectedPaymentType === 1 ? 3 : 1, // 主网口带宽计费模式
				bandwidthPackageId: this.netInfo.sharedBandwidthForm.selectBandwidthPackage, // 主网口共享带宽ID
				enableIpv6: this.netInfo.privateIpv6Visible ? "yes" : "no", // 主网口内网IPV6
				extensionVpc: this.extensionNetInfo.selectVpcName,
				extensionSubnet: this.extensionNetInfo.selectSubnetName,
				extensionSubnetId: this.extensionNetInfo.selectSubnetId,
				extensionSubnetCidr: this.extensionNetInfo.selectSubnetCidr,
				extensionLineType: this.extensionNetInfo.selectedLineType,
				extensionBw: this.extensionNetInfo.radioIp ? this.extensionNetInfo.selectedMaxBandwidth : 0,
				extensionInternetChargeMode: this.extensionNetInfo.selectedPaymentType === 1 ? 3 : 1,
				extensionBandwidthPackageId: this.extensionNetInfo.sharedBandwidthForm.selectBandwidthPackage,
				extensionEnableIpv6: this.extensionNetInfo.privateIpv6Visible ? "yes" : "no",
				name: this.ruleForm.hostName,
				description: this.ruleForm.hostDesc,
				chargeDuration: this.chargeUnit == 3 ? this.selectedMonth : this.selectedYear,
				chargeUnit: this.chargeUnit, // 月 计费时长单位 1:小时 2:天 3:月 4:年
				quantity: this.selectedHostNumber,
				clientToken: Normal.getClientToken(),
				timestamps: Normal.getClientToken(),
				autoRenew: this.autoRenew,
				hostname: this.ruleForm.mainName,
				networkType: 'vpc',
				createType: 'vpc',
				userData: this.advancedSetting ? this.userData : undefined, // 高级设置的脚本
				resourceTags: this.tagForm.tags,
				systemDiskPartitions,
				dataDiskPartitions
			};
			if (this.formattedAliasIpTableData.length >= 1) {
				param.aliasIps = this.formattedAliasIpTableData;
			}

			if (this.formattedIpv6TableData.length >= 1) {
				param.ipv6AliasIps = this.formattedIpv6TableData;
			}

			if (this.formattedExtensionAliasIpTableData && this.formattedExtensionAliasIpTableData.length >= 1) {
				param.extensionAliasIps = this.formattedExtensionAliasIpTableData;
			}

			if (this.formattedExtensionIpv6TableData && this.formattedExtensionIpv6TableData.length >= 1) {
				param.extensionIpv6AliasIps = this.formattedExtensionIpv6TableData;
			}

			if (!this.netInfo.isAuto) {
				if (this.netInfo.internetIp !== '') {
					param.privateIp = this.netInfo.internetIp;
				}
			}
			if (!this.extensionNetInfo.isAuto) {
				if (this.extensionNetInfo.internetIp !== '') {
					param.extensionPrivateIp = this.extensionNetInfo.internetIp;
				}
			}
			if (!this.netInfo.isPrivateIpv6Auto) {
				if (this.netInfo.privateIpv6 !== '') {
					param.ipv6Address = this.privateIpv6Pre + this.netInfo.privateIpv6;
				}
			}
			if (!this.extensionNetInfo.isPrivateIpv6Auto) {
				if (this.extensionNetInfo.privateIpv6 !== '') {
					param.extensionIpv6Address = this.extensionPrivateIpv6Pre + this.extensionNetInfo.privateIpv6;
				}
			}

			if (this.netInfo.radioIp) {
				param.enableInternet = 'yes';
			}
			if (this.extensionNetInfo.radioIp) {
				param.extensionEnableInternet = 'yes';
			}
			// 密钥登陆参数处理
			if (this.passwordType === 'custom') {
				param.loginType = 'pwd';
				param.password = this.ruleForm.hostPwd;
				if (this.setKeyState) {
					param.keypairIdSos = this.ruleForm.selectKey;
				}
			} else if (this.passwordType === 'key') {
				param.loginType = 'keyPair';
				param.password = '';
				param.keyPairId = this.ruleForm.selectKey;
				param.keypairIdSos = this.ruleForm.sosKey;
			} else {
				param.loginType = 'autoPwd';
				if (this.setKeyState) {
					param.keypairIdSos = this.ruleForm.selectKey;
				}
			}
			Ajax.post('/api/cps/instances/createInstance', param, {
				headers: {
					'Content-Type': 'application/json'
				}
			}).then((res) => {
				const orderId = res.data.tempOrderNumber;
				if (orderId !== '' && orderId !== undefined) {
					window.location.href = `${this.Config.ORDER_URL}/confirm?buyId=${orderId}&source=1`;
				}
			})
				.catch(async (err) => {
					const { response } = err.data;
					try {
						const json = await response.json();
						this.$message.error(json.errmsg);
					} catch (ex) {
						console.log(ex);
					}
				});
		},
		setTab(name, cursel, n) {
			this.initBandwidthPaymentTypes(cursel);
			if (!this.isVip) {
				n = 1;
			}
			for (let i = 1; i <= n; i++) {
				const menu = document.getElementById(name + i);
				const con = document.getElementById(`con-${name}-${i}`);
				menu.className = i == cursel ? 'hover' : '';
			}
			this.currentMode = name + cursel;
		},
		initBandwidthPaymentTypes(cursel) {
			if (cursel === 2) {
				this.bandwidthPaymentTypes = [
					{ label: this.$t('create.text.fixedBandwidthPostpaid'), value: 2, key: 2 },
					{ label: this.$t('eip.text.joinShareBandwidth'), value: 3, key: 3 },
				];
				this.netInfo.selectedPaymentType = 2;
				this.extensionNetInfo.selectedPaymentType = 2;
			} else {
				this.bandwidthPaymentTypes = [
					{ label: this.$t('create.text.fixedBandwidthPrepaid'), value: 1, key: 1 },
					{ label: this.$t('eip.text.joinShareBandwidth'), value: 3, key: 3 }
				];
				this.netInfo.selectedPaymentType = 1;
				this.extensionNetInfo.selectedPaymentType = 1;
			}
			if (!this.isVip) {
				this.bandwidthPaymentTypes = [
					{ label: this.$t('create.text.fixedBandwidthPrepaid'), value: 1, key: 1 },
				];
			}
		},
		showPrivateIpv6(tag) {
			this[tag].privateIpv6Visible = true;
		},
		closePrivateIpv6(tag) {
			this[tag].privateIpv6Visible = false;
			this[tag].isPrivateIpv6Auto = 1;
			this[tag].privateIpv6 = '';
		},
		// 获取折扣信息
		getDiscountInfo() {
			const param = {
				serviceCode: ServiceCodeConstant["CPS|EIP"],
				billType: 2, // 包年包月
				billPeriod: '1,2,3',
				timeUnit: 4, // 年
				region: this.selectedRegion,
				buyType: 1// 1、新购2、续费3、配置变更
			};
			Ajax.get({
				url: '/api/discount',
				action: '/describeLowestDiscount',
				param,
				success: (data) => {
					if (data.length > 0) {
						for (let i = 0; i < data.length; i++) {
							this.allDiscountedInfo[i].message[0] = data[i].discounts[0].message;
							this.allDiscountedInfo[i].message[1] = data[i].discounts[1].message;
						}
					}
				}
			});
		},

		doClose() {
			this.dialogVisible = false;
		},
		doConfirm() {
			this.dialogVisible = false;
		},
		getCurrentSeries(selectedStandard) {
			const allSeries = this.deviceTypesTable;
			for (const item in allSeries) {
				for (const deviceItem in allSeries[item]) {
					if (allSeries[item][deviceItem].deviceType === selectedStandard) {
						this.selectedSeries = item;
					}
				}
			}
		},
		isIncludeBra(value) {
			if (value.includes('(') && value.includes('generation')) {
				return value.replace('(', '<br>(');
			}
			if (value.includes('（') && value.includes('generation')) {
				return value.replace('（', '<br>（');
			}
			return value;
		},

		// 添加标签错误处理
		errorHandler(err) {
			console.log(err)
		},


		jumpToSubnetList() {
			this.$router.push({
				path: '/subnet/list',
			})
		},

		jumpToVpcList() {
			this.$router.push({
				path: '/vpc/list',
			})
		},
		trimValue(type) {
			if (type === 'internetIp') {
				this.netInfo.internetIp = this.netInfo.internetIp.replace(/^\s+|\s+$/g, '');
			} else if (type === 'privateIpv6') {
				this.netInfo.privateIpv6 = this.netInfo.privateIpv6.replace(/^\s+|\s+$/g, '');
			}
		},

		/**
		 **@disc: 添加别名IP范围
		 */
		addAliasIpRange(tag) {
			if (tag === 'netInfo') {
				if (!this.selectedSubnetDetail.cidr) {
					return false;
				}
				if (this.addAliasIpRangeVisible === false) {
					this.addAliasIpRangeVisible = true;
				} else {
					if (this.aliasIpRestNumber('netInfo') || this.aliasIpv6RestNumber('netInfo')) {
						this.$refs.addAliasIpRange.addOneRow();

					} else {
						return false
					}
				}
			} else if (tag === 'extensionNetInfo') {
				if (!this.selectedExtensionSubnetDetail.cidr) {
					return false;
				}
				if (this.extensionAddAliasIpRangeVisible === false) {
					this.extensionAddAliasIpRangeVisible = true;
				} else {
					if (this.aliasIpRestNumber('extensionNetInfo') || this.aliasIpv6RestNumber('extensionNetInfo')) {
						this.$refs.extensionAddAliasIpRange.addOneRow();
					} else {
						return false
					}
				}
			}
		},

		/**
		 * 折叠已选配置项
		*/
		collapseSelected(tag) {
			this[tag].collapseSelected = !(this[tag].collapseSelected);
		},

		addIconDisabled(type) {
			if (this.aliasIpRestNumber(type) === 0 && this.aliasIpv6RestNumber(type) === 0) {
				return true
			} else {
				return false
			}
		},

		generateGuid() {
			return guid();
		}
	}
};
</script>

<style lang="scss">
@import '../../../assets/scss/createCommon';
@import '../../../assets/scss/selectedConfigure';
@import '../../../assets/scss/statusCommon';
@import '../../../assets/scss/sliderCommon';
@import 'style';
.body-overflow-hidden {
    overflow: hidden;
}
.create-container {
	.search-input {
		width: 200px !important;
		margin: 5px;
	}

	.search-icon {
		margin: 5px;
	}

	.search-label {
		padding-top: 10px;
	}

	.select-type {
		display: flex;
		flex-direction: row;
		justify-content: flex-start;
		margin-left: 130px;
		border-left: 1px solid #dbe3e9;
		border-right: 1px solid #dbe3e9;
		border-top: 1px solid #dbe3e9;
		padding: 5px 5px 5px 10px;

	}

	.defaultPartition {
		span {
			color: #9e9e9e;
		}
	}
    .dataDiskCardBox:not(.selected-box-card) {
        border: 1px solid #dbe3e9d1;
    }
}
</style>
<style lang="scss" scoped>
.price {
	font-size: 22px !important;
}
</style>



// WEBPACK FOOTER //
// src/views/privateNetInstance/create/InstanceCreate.vue